import React, { useState, useEffect, useRef } from "react";
import { Label, Input, Button, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { Prompt, useHistory, useLocation } from "react-router-dom";
import ReactChipInput from "react-chip-input";
//components
import ShowIcon from "../../common/Components/Icons/ShowIcon";
import HideIcon from "../../common/Components/Icons/HideIcon";
import { debounce } from "../../common/commonFiles/debounce";
import Loader from "../../common/Components/Loader/Loader";
import notifications from "../../common/Components/Notifications/Notification";
import FilePreviewPart from "./FilePreviewPart";
import ProductImagePreView from "./ProductImagePreView";
import {
  ProcessStepsSection,
  parseProcessStepsFromApi,
  serializeProcessStepsForApi,
} from "./ProcessStepsSection";
import {
  FlexibleMediaProcessesSection,
  buildFlexSlotsFromProduct,
  defaultLegacyFlexSlots,
  flexSlotsToPayloadProcesses,
  toProcessMasterOption,
  ProcessMasterOption,
} from "./FlexibleMediaProcessesSection";
import {
  cancelProductMedia,
  currentUploadOwnerKey,
  enqueueProductMedia,
  getUploadJobs,
  retryProductMedia,
  summarizeUploads,
} from "../../uploads/productMediaUploadManager";
import {
  addDraftKey,
  AddDraftSnapshot,
  buildAddDraft,
  clearAddDraft,
  loadAddDraft,
  saveAddDraft,
  mediaCountWords,
  savedAgo,
} from "./steps/addDraftLocal";
import { useProductMediaUploads } from "../../uploads/ProductMediaUploadContext";
import { masterIdFromRef } from "../../uploads/productDraftApi";
import { baseImageCovert } from "./baseImageConver";
import ImageClose from "../../common/Components/Icons/ImageClose";
import ImageAddIcon from "../../common/Components/Icons/ImageAddIcon";
import ProductDesignIcon from "../../common/Components/Icons/ProductDesignIcon";
import ProductWeaveIcon from "../../common/Components/Icons/ProductWeaveIcon";
import ProductFinishIcon from "../../common/Components/Icons/ProductFinishIcon";
import ImageDivPart from "./ImageDivPart";
import ArtformModal from "../artform/ArtformModal";
import GiFrozenSelect from "../gi-registry/GiFrozenSelect";
import StudioOrderSelect from "../orders/StudioOrderSelect";
import { canUseOrders } from "../../helpers/orderEnabled";
import { canUseProductCapture } from "../../helpers/productCaptureEnabled";
import ProductAttributesSection from "../../taxonomy/ProductAttributesSection";
import { getOrganizationTaxonomyConfig, listProcessFieldMappingsByProcess } from "../../taxonomy/taxonomyApi";
import type { ResolvedFieldConfig, TaxonomyValues } from "../../taxonomy/types";
import {
  isWeaveTypeApplicable,
  mergeTaxonomyValues,
  parseCustomFieldsRequired,
} from "../../taxonomy/values";
import { missingPublishFields as collectMissingPublishFields, resolvePublishFailure, RequiredField } from "../../taxonomy/publishFields";
import { customFieldsCopy } from "../../taxonomy/copy";
import TypeModal from "../type/TypeModal";
import CategoryModal from "../category/CategoryModal";
import SubCategoryModal from "../sub-category/SubCategoryModal";
import WeaveTypeModal from "../weave-type/WeaveTypeModal";
import CircleLoader from "../../common/Components/Loader/CircleLoader";

// actions
import { getArtforms } from "../../Store/artform/actions";
import { createUser, updateUsers } from "../../Store/users/actions";
import {
  fetchProfilePresignedUrl,
  fetchProductWeavingPresignedUrl,
  fetchProductDesigningPresignedUrl,
  fetchProductFinishingPresignedUrl,
  fetchProductDyingPresignedUrl,
  uploadImages1,
  uploadImages,
} from "../../Store/uploadModule/actions";
import { getUsers } from "../../Store/users/actions";
import { getCategory } from "../../Store/actions";
import { getSubCategorys } from "../../Store/actions";
import { getTypes } from "../../Store/type/actions";
import { getWeaveType } from "../../Store/weave-type/actions";
import { createProduct, getProducts } from "../../Store/products/actions";
import { AddIcon } from "../../common/Components/Icons/AddIcon";
import CreateUserModal from "../users/CreateUserModal";
import CreateProductHeader from "./CreateProductHeader";
import Pin from "../../common/Components/Icons/Pin";
import Unpin from "../../common/Components/Icons/Unpin";
import ResetIcon from "../../common/Components/Icons/ResetIcon";

import {
  zariUsedOptions,
  timeTakenInMonthsOptions,
  yarnUsedOptions,
  typeOfSareeByDesignOptions,
} from "./options";
import { isSareeLikeProduct, productWeightLabel } from "./productSareeFields";
import {
  collectUniqueFiles,
  mergePersistedWithLocalPreviews,
  mediaForProductWrite,
  persistableThumbnailRows,
  replaceLocalPreviewsWithUploaded,
  shouldShowMediaUploadSpinner,
  mediaItemsAtVisibleIndexes,
  dropMediaItems,
  itemPersistableUrl,
} from "./previewMedia";
import { getUploadJob } from "../../uploads/productMediaUploadIdb";
import { getApi, postApi } from "../../helpers/auth_helpers";
import ProductDescriptionField from "./common components/ProductDescriptionField";
import {
  fetchNextOrgSrNo,
  parseOrgSrNo,
  resolveHkpTagLookup,
} from "../../services/hkpNfcTagApi";
import {
  DetailsGroup,
  ProductStepFooter,
  ProductStepHeader,
  ProductStepPanel,
  StepButton,
} from "./steps/ProductStepShell";
import TypeTagPicker from "./steps/TypeTagPicker";
import { isTypeTagsEnabled } from "../../helpers/typeTagsEnabled";
import { ProductStepId, stepFromSearch, stepIndex, stepOfElement } from "./steps/productSteps";
import CategoryPathPicker from "./steps/CategoryPathPicker";
import { CategoryPath } from "./steps/categoryPathSearch";
import WriteFromPhotos from "./steps/WriteFromPhotos";
import PhotoGrid from "./steps/PhotoGrid";
import { coverageOf, missingWords, normalizeSkipped, viewSlotsFor } from "./steps/mediaViews";
import ColourChips from "./steps/ColourChips";

var productOptions: any = [];
var artformOptions: any = [];
var typeOptions: any = [];
var categoryOptions: any = [];
var designerOptions: any = [];
var weaverOptions: any = [];
var dyerOptions: any = [];
var finisherOptions: any = [];
let subCategoryOptions: any = [];
let weaveTypeOptions: any = [];

// logo
let fileObjLogo: any = [];
let fileArrayLogo: any = [];
let promiseForLogo: any = [];
let promiseLogoUrl: any = [];
let promiseLogoStatusCode: any = [];

// designing
let fileObjDesign: any = [];
let fileArray: any = [];
let promiseForDesign: any = [];
let promiseDesignUrl: any = [];
let promiseDesignStatusCode: any = [];
// weaving
let fileObjWeaving: any = [];
let fileArrayWeaving: any = [];
let promiseForWeaving: any = [];
let proWeavingUrl: any = [];
let proWeavingCodes: any = [];
// dying
let fileObjDying: any = [];
let fileArrayDying: any = [];
let promiseForDying: any = [];
let proDyingUrl: any = [];
let proDyingCodes: any = [];
// finishing
let fileObjFinishing: any = [];
let fileArrayFinishing: any = [];
let promiseForFinishing: any = [];
let proFinishingUrl: any = [];
let proFinishingUCodes: any = [];
// variant
let fileObjVariant: any = [];
let fileArrayVariant: any = [];
let promiseForVariant: any = [];
let promiseVariantUrl: any = [];
let promiseVariantStatusCode: any = [];

let allStatusCodes: any = [];
let productMainImageStatusCode: any = [];
let fileObjImages: any = [];
type ProcessMasterOpt = ProcessMasterOption;

let finishingRoleIds = [
  "63c64da18667bd64a57c6303",
  "63c64da18667bd64a57c6302",
  "63c64da18667bd64a57c6301",
];

const CreateProduct = (props: any) => {
  const history = useHistory();
  const location: any = useLocation();
  let productCount: any = localStorage?.getItem("ProductCount");
  const [form, setForm]: any = useState({
    artform: "",
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    productName: "",
    designer: "",
    designerMedia: [],
    weaver: "",
    weaverMedia: [],
    dyer: "",
    dyerMedia: [],
    finisher: "",
    finisherMedia: [],
    profileURL: [],
    tags: [],
    singleTag: "",
    variantCode: "",
    description: "",
    variantImages: [],
    // new
    nameOfBrand: "",
    nameOfWeaver: "",
    weightOfSaree: "",
    zariUsed: "",
    silkMark: "",
    handloomMark: "",
    madeInIndia: true,
    weightOfZariUsed: "",
    workingHours: "",
    yarnType: "",
    loomNum: "",
    xuid: "",
    xuidFromRegistry: false,
    // new fields
    SrNo: "",
    orgSrNo:"",
    weavingCenter: "Varanasi",
    giId: "",
    typeOfSareeByDesign: "",
    productionTimeInMonths: "",
    parentId: "",
    sellPrice: "",
    costPrice: "",
    designNum: "",
    processSteps: [] as { title: string; text: string }[],
    flexUploadSlots: defaultLegacyFlexSlots(),
    taxonomyValues: {} as TaxonomyValues,
    studioOrderId:
      new URLSearchParams(location.search || "").get("orderId") || "",
    studioOrderCode:
      new URLSearchParams(location.search || "").get("orderCode") || "",
  });
  const [flexPendingFiles, setFlexPendingFiles] = useState<Record<string, File[]>>({});
  const uploadJobs = useProductMediaUploads("");
  const [processMasterOptions, setProcessMasterOptions] = useState<ProcessMasterOpt[]>([]);
  const [productTaxonomyFields, setProductTaxonomyFields] = useState<ResolvedFieldConfig[]>([]);
  const [processTaxonomyFields, setProcessTaxonomyFields] = useState<ResolvedFieldConfig[]>([]);
  // Main-image preview, wired the same way as EditProduct.
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage]: any = useState("");
  const handleOpen = () => setIsPreviewOpen(true);
  const handleSetImage = (image: any) => setPreviewImage(image);
  const [taxonomyConfigError, setTaxonomyConfigError] = useState("");
  const [taxonomyConfigLoading, setTaxonomyConfigLoading] = useState(false);
  const [missingPublishFields, setMissingPublishFields] = useState<RequiredField[]>([]);
  const [weaveTypeApplicable, setWeaveTypeApplicable] = useState(true);
  const showRequiredFields = async (response: any) => {
    const ids = parseCustomFieldsRequired(response);
    if (!ids.length) return false;
    const [productRes, processRes] = await Promise.all([
      getOrganizationTaxonomyConfig("PRODUCT"), getOrganizationTaxonomyConfig("PROCESS"),
    ]);
    const productFields = productRes.success ? productRes.data || [] : productTaxonomyFields;
    const processFields = processRes.success ? processRes.data || [] : processTaxonomyFields;
    setProductTaxonomyFields(productFields);
    setProcessTaxonomyFields(processFields);
    setMissingPublishFields(await resolvePublishFailure(ids, productFields, form.taxonomyValues,
      processFields, form.flexUploadSlots || [], processMasterOptions));
    document.getElementById("hkp-product-attributes")?.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  };


  const [selectedProduct, setSelectedProduct]: any = useState();
  const [switchButton, setSwitchButton]: any = useState(false);
  const [filterProduct, setFilterProduct]: any = useState("");
  const [loading, setLoading]: any = useState(false);
  const [baseImageLogo, setBaseImageLogo]: any = useState([]);
  // Set right before leaving after a successful save, so the unsaved-work prompt lets it through.
  const savedRef = useRef(false);
  // Blocks a second Save/Publish while one is in flight; set before any await in handleSubmit.
  const submittingRef = useRef(false);
  const [saving, setSaving] = useState<null | "save" | "publish">(null);
  // Add product shows Photos and Basics; "Next" on Basics saves the draft and opens it in Edit at Details.
  const isVariant = location?.state?.name === "variant";
  const [step, setStep] = useState<ProductStepId>(() => {
    const fromUrl = stepFromSearch(location?.search, "photos");
    return fromUrl === "photos" ? "photos" : "basics";
  });
  const [levelsOpen, setLevelsOpen] = useState(false);
  const continueStepRef = useRef<ProductStepId | null>(null);
  const releaseSubmit = () => {
    submittingRef.current = false;
    setSaving(null);
  };
  const [baseImageDying, setBaseImageDying]: any = useState([]);
  const [baseImageDesigner, setBaseImageDesigner]: any = useState([]);
  const [baseImageVariant, setBaseImageVariant]: any = useState([]);
  const [deleteIndexLogo, setDeleteIndexLogo]: any = useState();
  const [deleteIndexDesigner, setDeleteIndexDesigner]: any = useState();
  const [deleteIndexWeaver, setDeleteIndexWeaver]: any = useState();
  const [deleteIndexDying, setDeleteIndexDying]: any = useState();
  const [deleteIndexFinisher, setDeleteIndexFinisher]: any = useState();
  const [deleteIndexVariant, setDeleteIndexVariant]: any = useState();

  const [baseImageWeaver, setBaseImageWeaver]: any = useState([]);
  const [baseImageFinisher, setBaseImageFinisher]: any = useState([]);
  const visibleMediaIds = [
    ...(baseImageLogo || []).map((img: any) => img?.mediaId),
    ...(baseImageVariant || []).map((img: any) => img?.mediaId),
    ...((form.flexUploadSlots || []).flatMap((slot: any) =>
      (slot.baseImages || []).map((img: any) => img?.mediaId)
    )),
  ].filter(Boolean);
  const uploadSummary = summarizeUploads("", visibleMediaIds);

  const [selectedFile, setSelectedFile]: any = useState();
  const [selectedFileDying, setSelectedFileDying]: any = useState();
  const [selectedFileWeaver, setSelectedFileWeaver]: any = useState();
  const [selectedFileDesigner, setSelectedFileDesigner]: any = useState();
  const [selectedFileFinisher, setSelectedFileFinisher]: any = useState();
  const [selectedFileVariant, setSelectedFileVariant]: any = useState();
  const [selectTab, setSelectTab]: any = useState("");
  const [selectTab1, setSelectTab1]: any = useState("");
  const [baseindex, setBaseIndex]: any = useState({
    designing: "",
    dying: "",
    weaving: "",
    finishing: "",
    logo: "",
  });
  const [baseindexForLogo, setBaseIndexForLogo]: any = useState("");
  const [Error, setError]: any = React.useState({
    artform: "",
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    variantImages: "",
    variantCode: "",
    SrNo: "",
  });
  const [openModal, setOpenModal]: any = useState({
    artform: false,
    type: false,
    category: false,
    subCategory: false,
    weaveType: false,
    designing: false,
    dying: false,
    weaving: false,
    finishing: false,
  });
  const [filterValue, setFilterValue]: any = useState({
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    product: "",
  });
  const [loader, setLoader]: any = useState(
    false
  );
  const [handleNameFlag, setHandleNameFlag]: any = useState({
    designing: false,
    weaving: false,
    dying: false,
    finishing: false,
  });
  const [mainImageLoader, setMainImageLoader]: any = useState(false);
  const fileInputProfile: any = React.useRef();
  const fileInputDesigner: any = React.useRef();
  const fileInputWeaver: any = React.useRef();
  const fileInputUploadDying: any = React.useRef();
  const fileInputFinisher: any = React.useRef();
  const fileInputVariant: any = React.useRef();

  let auth: any = localStorage.getItem("authUser");
  let authUser: any = JSON.parse(auth) || "";
  let organizationId =
    authUser?.users?.role === "ORGANIZATION_MANAGER" ||
      authUser?.users?.role === "ORGANIZATION_ADMIN"
      ? authUser?.users?.organizationResponse?._id
      : "";
  const fileUploadTriggerVariant = () => {
    fileInputVariant.current.click();
  };
  const fileUploadTrigger = () => {
    fileInputProfile.current.click();
  };
  const fileUploadTriggerWeaver = () => {
    fileInputWeaver.current.click();
  };
  const fileUploadTriggerDesigner = () => {
    fileInputDesigner.current.click();
  };

  const fileUploadTriggerFinisher = () => {
    fileInputFinisher.current.click();
  };

  const fileUploadTriggerDying = () => {
    fileInputUploadDying.current.click();
  };
  const handleSwitchButton = (checked: boolean) => {
    setSwitchButton(checked);
  };
  const assignNextOrgSrNo = (force = false) => {
    fetchNextOrgSrNo().then((n) => {
      if (n == null) {
        return;
      }
      setForm((current: any) => {
        const empty = current?.orgSrNo === "" || current?.orgSrNo == null;
        return {
          ...current,
          orgSrNo: force || empty ? n : current.orgSrNo,
        };
      });
    });
  };
  const handleHkpTagNoBlur = async (tagNo: string) => {
    const result = await resolveHkpTagLookup(tagNo, form?.productUniqueId);
    if (result.fromRegistry && result.xuid) {
      setForm((current: any) => ({
        ...current,
        xuid: result.xuid,
        xuidFromRegistry: true,
      }));
      return;
    }
    if (result.legacy) {
      setForm((current: any) => ({
        ...current,
        xuidFromRegistry: false,
        xuid: current?.xuidFromRegistry ? "" : current?.xuid,
      }));
      return;
    }
    if (result.error) {
      notifications({
        title: "HKP tag",
        message: result.error,
        type: "danger",
      });
      setForm((current: any) => ({ ...current, xuidFromRegistry: false }));
    }
  };
  useEffect(() => {
    // if (location.pathname.split("/")[1] === "edit-product") {
    resetVariables();
    fileArray = [];
    fileArrayDying = [];
    fileArrayFinishing = [];
    fileArrayWeaving = [];
    fileObjDesign = [];
    fileObjDying = [];
    fileObjLogo = [];
    fileObjFinishing = [];
    fileObjWeaving = [];
    fileObjVariant = [];
    productMainImageStatusCode = [];
    // uniqueArr = [];
    // }
  }, []);
  useEffect(() => {
    if (!uploadJobs.length) {
      return;
    }
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: (f.flexUploadSlots || []).map((s: any) => ({
        ...s,
        baseImages: (s.baseImages || []).map((img: any) => {
          const job = uploadJobs.find((j) => j.mediaId && j.mediaId === img.mediaId);
          if (!job) {
            return img;
          }
          if (!job.storageUrl) {
            return {
              ...img,
              mediaId: job.mediaId,
              uploadStatus: job.status,
              uploadProgress: job.progress,
              uploadError: job.error,
            };
          }
          return {
            ...img,
            mediaId: job.mediaId,
            uploadStatus: job.status,
            uploadProgress: job.progress,
            blobImage: job.storageUrl,
            mediaURL: job.storageUrl,
            mediaUrl: job.storageUrl,
            mediaAssetId: job.mediaAssetId || img.mediaAssetId,
            _local: false,
          };
        }),
      })),
    }));
    setBaseImageLogo((prev: any[]) =>
      (prev || []).map((img: any) => {
        const job = uploadJobs.find((j) => j.mediaId && j.mediaId === img.mediaId);
        if (!job) {
          return img;
        }
        if (!job.storageUrl) {
          return {
            ...img,
            mediaId: job.mediaId,
            uploadStatus: job.status,
            uploadProgress: job.progress,
            uploadError: job.error,
          };
        }
        return {
          ...img,
          mediaId: job.mediaId,
          uploadStatus: job.status,
          uploadProgress: job.progress,
          blobImage: job.storageUrl,
          mediaURL: job.storageUrl,
          mediaUrl: job.storageUrl,
          mediaAssetId: job.mediaAssetId || img.mediaAssetId,
          _local: false,
        };
      })
    );
  }, [uploadJobs]);
  useEffect(() => {
    let cancelled = false;
    setTaxonomyConfigLoading(true);
    Promise.all([
      getOrganizationTaxonomyConfig("PRODUCT"),
      getOrganizationTaxonomyConfig("PROCESS"),
    ]).then(([productRes, processRes]) => {
      if (cancelled) return;
      if (productRes.success) {
        setProductTaxonomyFields(productRes.data || []);
        setWeaveTypeApplicable(isWeaveTypeApplicable(productRes.data));
        setTaxonomyConfigError("");
      } else {
        setTaxonomyConfigError(customFieldsCopy.configLoadWarning);
      }
      if (processRes.success) {
        setProcessTaxonomyFields(processRes.data || []);
      } else {
        setTaxonomyConfigError(customFieldsCopy.configLoadWarning);
      }
      setTaxonomyConfigLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    if (location?.state?.name === "variant") {
      return;
    }
    assignNextOrgSrNo(false);
  }, []);

  const loadProcessMasters = async () => {
    try {
      const url = `${process.env.REACT_APP_SERVERURL}/product-process-master/list`;
      const response: any = await getApi(url);
      if (response?.success && Array.isArray(response?.data)) {
        const next = await Promise.all(response.data.map(async (item: any) => {
          const base = toProcessMasterOption(item);
          const mappings = base.value ? await listProcessFieldMappingsByProcess(base.value) : null;
          return toProcessMasterOption(item, mappings?.success ? mappings.data || [] : undefined);
        }));
        setProcessMasterOptions(next);
      }
    } catch (error) {
      // keep form usable even if master API fails
    }
  };

  const createProcessMaster = async (name: string, description: string, inhouse: boolean) => {
    const payload = {
      name: String(name || "").trim(),
      description: String(description || "").trim(),
      inhouse,
    };
    if (!payload.name) return null;
    try {
      const url = `${process.env.REACT_APP_SERVERURL}/product-process-master/upsert`;
      const response: any = await postApi(url, payload);
      if (!response?.success || !response?.data) {
        notifications({
          title: "Error!",
          message: response?.message || "Unable to save process master",
          type: "danger",
        });
        return null;
      }
      const created = toProcessMasterOption({
        ...response.data,
        name: response.data?.name || payload.name,
        description: response.data?.description || payload.description,
        inhouse: response.data?.inhouse === false ? false : true,
      }, []);
      setProcessMasterOptions((prev) => {
        const rest = prev.filter((p) => p.label.toLowerCase() !== created.label.toLowerCase());
        return [...rest, created].sort((a, b) => a.label.localeCompare(b.label));
      });
      return created;
    } catch (error) {
      notifications({
        title: "Error!",
        message: "Unable to save process master",
        type: "danger",
      });
      return null;
    }
  };

  useEffect(() => {
    loadProcessMasters();
  }, []);
  const resetVariables = () => {
    // selector options
    productOptions = [];
    artformOptions = [];
    typeOptions = [];
    categoryOptions = [];
    designerOptions = [];
    weaverOptions = [];
    dyerOptions = [];
    finisherOptions = [];
    subCategoryOptions = [];
    weaveTypeOptions = [];

    // logo
    fileObjLogo = [];
    fileArrayLogo = [];
    promiseForLogo = [];
    promiseLogoUrl = [];
    promiseLogoStatusCode = [];

    // designing
    fileObjDesign = [];
    fileArray = [];
    promiseForDesign = [];
    promiseDesignUrl = [];
    promiseDesignStatusCode = [];
    // weaving
    fileObjWeaving = [];
    fileArrayWeaving = [];
    promiseForWeaving = [];
    proWeavingUrl = [];
    proWeavingCodes = [];
    // dying
    fileObjDying = [];
    fileArrayDying = [];
    promiseForDying = [];
    proDyingUrl = [];
    proDyingCodes = [];
    // finishing
    fileObjFinishing = [];
    fileArrayFinishing = [];
    promiseForFinishing = [];
    proFinishingUrl = [];
    proFinishingUCodes = [];
    // variant
    fileObjVariant = [];
    fileArrayVariant = [];
    promiseForVariant = [];
    promiseVariantUrl = [];
    promiseVariantStatusCode = [];

    allStatusCodes = [];
    productMainImageStatusCode = [];
    fileObjImages = [];
  };
  useEffect(() => {
    getArtformData();
    getCreatorsDataDesignerOption();
    getCreatorsDataDyingOption();
    getCreatorsDataFinishingOption();
    getCreatorsDataWeaverOption();
    CallingGettProductForFilter();
  }, []);

  useEffect(() => {
    if (location?.pathname === "/createProduct") {
      fileArray = [];
      fileArrayDying = [];
      fileArrayFinishing = [];
      fileArrayWeaving = [];
      fileObjDesign = [];
      fileObjDying = [];
      fileObjFinishing = [];
      fileObjWeaving = [];
      fileObjVariant = [];
      productMainImageStatusCode = [];
      const params = new URLSearchParams(location.search || "");
      const orderId = params.get("orderId") || "";
      const orderCode = params.get("orderCode") || "";
      if (orderId || orderCode) {
        setForm((current: any) => ({
          ...current,
          studioOrderId: orderId,
          studioOrderCode: orderCode,
        }));
      }
    }
  }, [location.pathname, location.search]);
  useEffect(() => {
    if (form?.type?.value?.length) {
      getCategoryData();
    }
  }, [form?.type?.value]);
  useEffect(() => {
    if (form?.artform?.value?.length) {
      getTypesData();
    }
  }, [form?.artform?.value]);
  useEffect(() => {
    if (form?.category?.value?.length) {
      getSubCategoryData();
    }
  }, [form?.category?.value]);
  useEffect(() => {
    if (form?.subCategory?.value?.length) {
      getWeaveTypeData();
    }
  }, [form?.subCategory?.value]);
  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexLogo,
      baseImage: baseImageLogo,
      media: form?.profileURL,
      selectedFiles: selectedFile,
      fileArr: fileObjLogo,
      name: "logo",
    });
  }, [deleteIndexLogo]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexVariant,
      baseImage: baseImageVariant,
      media: form?.variantImages,
      selectedFiles: selectedFileVariant,
      fileArr: fileObjVariant,
      name: "variant",
    });
  }, [deleteIndexVariant]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexDesigner,
      baseImage: baseImageDesigner,
      media: form?.designerMedia,
      selectedFiles: selectedFileDesigner,
      fileArr: fileObjDesign,
      name: "desinging",
    });
  }, [deleteIndexDesigner]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexWeaver,
      baseImage: baseImageWeaver,
      media: form?.weaverMedia,
      selectedFiles: selectedFileWeaver,
      fileArr: fileObjWeaving,
      name: "weaving",
    });
  }, [deleteIndexWeaver]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexDying,
      baseImage: baseImageDying,
      media: form?.dyerMedia,
      selectedFiles: selectedFileDying,
      fileArr: fileObjDying,
      name: "dying",
    });
  }, [deleteIndexDying]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexFinisher,
      baseImage: baseImageFinisher,
      media: form?.finisherMedia,
      selectedFiles: selectedFileFinisher,
      fileArr: fileObjFinishing,
      name: "finishing",
    });
  }, [deleteIndexFinisher]);

  // delete data  reuse function

  const deleteImagesByIndex = (data: any) => {
    let { deleteIndex, baseImage, media, selectedFiles, name, fileArr } = data;
    // By position only: rows without a local blob all share `undefined`, so matching on it removed them all.
    let deleteBaseImage = (baseImage || []).filter((ele: any, i: any) => i !== deleteIndex?.i);
    let deleteMedia =
      media?.length && media.filter((ele: any, i: any) => i !== deleteIndex?.i);
    let deletefileArray =
      fileArr?.length &&
      fileArr.filter(
        (ele: any, i: any) => ele?.name !== deleteIndex?.item?.fileName
      );
    let deleteSelectedFile =
      selectedFiles?.length &&
      selectedFiles.filter((ele: any) => ele?.name !== deleteIndex?.item?.fileName);
    if (name === "desinging") {
      fileObjDesign = deletefileArray?.length ? deletefileArray : [];
      setForm({
        ...form,
        designerMedia: deleteMedia,
      });
      setSelectedFileDesigner(deleteSelectedFile);
      setBaseImageDesigner([...deleteBaseImage]);
    } else if (name === "weaving") {
      fileObjWeaving = deletefileArray?.length ? deletefileArray : [];
      setSelectedFileWeaver(deleteSelectedFile);
      setForm({
        ...form,
        weaverMedia: deleteMedia,
      });
      setBaseImageWeaver([...deleteBaseImage]);
    } else if (name === "dying") {
      fileObjDying = deletefileArray?.length ? deletefileArray : [];
      setForm({
        ...form,
        dyerMedia: deleteMedia,
      });
      setBaseImageDying([...deleteBaseImage]);
      setSelectedFileDying(deleteSelectedFile);
    } else if (name === "finishing") {
      fileObjFinishing = deletefileArray?.length ? deletefileArray : [];
      setSelectedFileFinisher(deleteSelectedFile);
      setForm({
        ...form,
        finisherMedia: deleteMedia,
      });
      setBaseImageFinisher(deleteBaseImage);
    } else if (name === "variant") {
      fileObjVariant = deletefileArray?.length ? deletefileArray : [];
      setSelectedFileVariant(deleteSelectedFile);
      setForm({
        ...form,
        variantImages: deleteMedia,
      });
      setBaseImageVariant([...deleteBaseImage]);
    } else if (name === "logo") {
      fileObjLogo = deletefileArray?.length ? deletefileArray : [];
      setSelectedFile(deleteSelectedFile);
      setForm({
        ...form,
        profileURL: deleteMedia,
      });
      setBaseImageLogo([...deleteBaseImage]);
    }
  };

  // api calls
  const getWeaveTypeData = (data?: any) => {
    props.getWeaveType(
      {
        offset: 0,
        limit: 10,
        artformId: form?.artform?.value || data?.artform,
        typeId: form?.type?.value || data?.type,
        categoryId: form?.category?.value || data?.category,
        subCategoryId: form?.subCategory?.value || data?.subCategory,
        weaveTypeId: form?.weaveType?.value,
        weaveTypeName: data?.value,
      },
      (res: any) => {
        weaveTypeOptions = [];
        res?.data?.docs.map((ele: any) => {
          weaveTypeOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };

  const getSubCategoryData = (data?: any) => {
    props.getSubCategorys(
      {
        offset: 0,
        limit: 10,
        artformId: form?.artform?.value || data?.artform,
        typeId: form?.type?.value || data?.type,
        categoryId: form?.category?.value || data?.category,
        // subCategoryId: form?.subCategory?.value || data?.subCategory,
        subCategoryName: data?.value,
      },
      (res: any) => {
        subCategoryOptions = [];
        res?.data?.docs.map((ele: any) => {
          subCategoryOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getCreatorsData = (data?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        userId: data?.userId,
      },
      (res: any) => {
        designerOptions = [];
        res?.data?.docs.map((ele: any) => {
          let formValues = form;
          if (data?.name === "designing") {
            formValues = {
              ...formValues,
              designer: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
                // {
                //   id: res?.data?.docs[0]?._id,
                //   roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                // },
              },
            };
            getCreatorsDataDesignerOption();
          }
          if (data?.name === "weaving") {
            formValues = {
              ...formValues,
              weaver: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
                // {
                //   id: res?.data?.docs[0]?._id,
                //   roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                // },
              },
            };
            getCreatorsDataWeaverOption();
          }
          if (data?.name === "dying") {
            formValues = {
              ...formValues,
              dyer: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
                // {
                //   id: res?.data?.docs[0]?._id,
                //   roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                // },
              },
            };
            getCreatorsDataDyingOption();
          }
          if (data?.name === "finishing") {
            formValues = {
              ...formValues,
              finisher: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
                // {
                //   id: res?.data?.docs[0]?._id,
                //   roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                // },
              },
            };
            getCreatorsDataFinishingOption();
          }
          setForm(formValues);
        });
      }
    );
  };
  const getCreatorsDataDesignerOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: "63c64da18667bd64a57c62fe",
      },
      (res: any) => {
        designerOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (ele?.businessRoleDetails[0]?.role === "NAQSEBAND") {
            designerOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCreatorsDataWeaverOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: "63c64da18667bd64a57c62ff",
      },
      (res: any) => {
        weaverOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (ele?.businessRoleDetails[0]?.role === "WEAVER") {
            weaverOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCreatorsDataDyingOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: "63c64da18667bd64a57c6300",
      },
      (res: any) => {
        dyerOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (ele?.businessRoleDetails[0]?.role === "DYER") {
            dyerOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCreatorsDataFinishingOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: [...finishingRoleIds],
      },
      (res: any) => {
        finisherOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (
            ele?.businessRoleDetails[0]?.role === "RAFUGAR" ||
            ele?.businessRoleDetails[0]?.role === "STAIN_MASTER" ||
            ele?.businessRoleDetails[0]?.role === "TASSEL"
          ) {
            finisherOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCategoryData = (data?: any) => {
    props.getCategory(
      {
        offset: 0,
        limit: 10,
        artformId: form?.artform?.value || data?.artform,
        typeId: form?.type?.value || data?.type,
        categoryName: data?.value,
      },
      (res: any) => {
        categoryOptions = [];
        res?.data?.docs.map((ele: any) => {
          categoryOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getTypesData = (data?: any) => {
    props.getTypes(
      {
        offset: 0,
        limit: 10,
        artFormId: form?.artform?.value || data?.artform,
        typeName: data?.value,
      },
      (res: any) => {
        typeOptions = [];
        res?.data?.docs.map((ele: any) => {
          typeOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const CallingGettProductForFilter = (value?: any) => {
    props.getProducts(
      {
        offset: 0,
        limit: 10,
        ProductsName: value?.value,
      },
      (res: any) => {
        setLoading(false);
        if (res?.data?.docs?.length) {
          productOptions = [];
          res.data?.docs.map((ele: any, i: any) => {
            // setForm({
            //   ...form,
            //   parentId: ele?.parentId,
            // });
            productOptions.push({
              label: ele?.name,
              value: {
                id: ele?._id,
                artform: ele?.artform,
                type: ele?.type,
                category: ele?.category,
                subCategory: ele?.subcategory,
                weaveType: ele?.weavetype,
                productName: ele?.name,
                tags: ele?.tags,
                parentId: ele?.parentId,
              },
            });
          });
        }
      }
    );
  };
  const CallingGettProduct = (value: any) => {
    props.getProducts(
      {
        offset: 0,
        limit: 10,
        ProductsName: value?.productName,
        artformId: value?.artform,
        typeId: value?.type,
        categoryId: value?.category,
        subCategoryId: value?.subCategory,
        weaveTypeId: value?.weaveType,
      },
      (res: any) => {
        setLoading(false);
        if (res?.data?.docs?.length) {
          res.data?.docs.map((ele: any, i: any) => {
            // setForm({
            //   ...form,
            //   parentId: ele?.parentId,
            // });
            if (value?.productName === ele?.name) {
              setFilterProduct(ele?.name);
            }
          });
        }
      }
    );
  };

  const getArtformData = (name?: any) => {
    props.getArtforms(
      {
        offset: 0,
        limit: 10,
        artformName: name,
      },
      (res: any) => {
        artformOptions = [];
        res?.data?.docs.map((ele: any) => {
          artformOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };

  const callingCreateProduct = (payload: any, msg?: any, snRetried = false) => {
    // let result: any = validate();
    // if (result?.length === 0) {
    // Keep the form mounted while saving; the buttons show progress instead.
    props.createProduct(payload, async (res: any) => {
      // Studio SN is set automatically. If another piece took this number a moment ago, take the next one and save again.
      if (!res?.success && !snRetried && /studio sn is already in use/i.test(String(res?.message || ""))) {
        // A failed lookup falls through to the normal error below, which also releases the Save button.
        const next = await fetchNextOrgSrNo().catch(() => null);
        if (next != null) {
          setForm((current: any) => ({ ...current, orgSrNo: next }));
          callingCreateProduct({ ...payload, orgSrNo: next }, msg, true);
          return;
        }
      }
      releaseSubmit();
      if (res.success) {
        savedRef.current = true;
        // The server draft exists now; Edit saves from here, so the device copy is done.
        clearAddDraft(localDraftKey);
        const newId = res?.data?.productUniqueId;
        const continueTo = continueStepRef.current;
        continueStepRef.current = null;
        // Going on to the next step: the header's "Draft saved" says it; a second popup would cover the form.
        if (!(continueTo && newId)) {
          notifications({
            title: "Success!",
            message: res?.message + " " + (msg?.length > 0 ? msg : ""),
            type: "success",
          });
        }
        if (continueTo && newId) {
          history.push(`/edit-product/${encodeURIComponent(newId)}?step=${continueTo}&new=1`);
        } else {
          history.push("/products");
        }
      } else if (parseCustomFieldsRequired(res).length) {
        await showRequiredFields(res);
      } else if (res?.status === 400) {
        notifications({
          title: "Error!",
          message: res?.detail || res?.message || "Could not save this product.",
          type: "danger",
        });
        resetVariables();

        // fileObjDesign = [];
        // fileObjDying = [];
        // fileObjFinishing = [];
        // fileObjWeaving = [];
        // fileObjVariant = [];
        // fileArray = [];
        // fileArrayDying = [];
        // fileArrayFinishing = [];
        // fileArrayWeaving = [];
        // allStatusCodes = [];
        // proFinishingUCodes = [];
        // proDyingCodes = [];
        // promiseDesignStatusCode = [];
        // proWeavingCodes = [];
        // proDyingUrl = [];
        // proWeavingUrl = [];
        // promiseDesignUrl = [];
        // proFinishingUrl = [];
        // promiseForDesign = [];
        // promiseForDying = [];
        // promiseForFinishing = [];
        // promiseForWeaving = [];
        // promiseForVariant = [];
        // promiseVariantUrl = [];
        // promiseVariantStatusCode = [];
        // fileArrayVariant = [];
        // fileObjLogo = [];
        // fileArrayLogo = [];
        // promiseForLogo = [];
        // promiseLogoUrl = [];
        // promiseLogoStatusCode = [];
      } else {
        notifications({
          title: "Error!",
          message: res?.message,
          type: "danger",
        });
        resetVariables();

        // fileObjDesign = [];
        // fileObjDying = [];
        // fileObjFinishing = [];
        // fileObjWeaving = [];
        // fileObjVariant = [];
        // fileArray = [];
        // fileArrayDying = [];
        // fileArrayFinishing = [];
        // fileArrayWeaving = [];
        // allStatusCodes = [];
        // proFinishingUCodes = [];
        // proDyingCodes = [];
        // promiseDesignStatusCode = [];
        // proWeavingCodes = [];
        // proDyingUrl = [];
        // proWeavingUrl = [];
        // promiseDesignUrl = [];
        // proFinishingUrl = [];
        // promiseForDesign = [];
        // promiseForDying = [];
        // promiseForFinishing = [];
        // promiseForWeaving = [];
        // promiseForVariant = [];
        // promiseVariantUrl = [];
        // promiseVariantStatusCode = [];
        // fileArrayVariant = [];
        // fileObjLogo = [];
        // fileArrayLogo = [];
        // promiseForLogo = [];
        // promiseLogoUrl = [];
        // promiseLogoStatusCode = [];
      }
    });
    // }
  };
  // Saving a draft needs only a name and colour; artform, type, category, sub-category and
  // weave type are needed to publish.
  const validate = (publishing = false) => {
    let error = "";
    let err = Error;

    if (publishing && (!masterIdFromRef(form?.artform))) {
      error = "Required";
      err = {
        ...err,
        artform: "ArtForm is Required!",
      };
    }
    if (publishing && (!masterIdFromRef(form?.type))) {
      error = "Required";
      err = {
        ...err,
        type: "Type Name is Required!",
      };
    }
    if (publishing && (!masterIdFromRef(form?.category))) {
      error = "Required";
      err = {
        ...err,
        category: "Category Name is Required!",
      };
    }
    if (publishing && (!masterIdFromRef(form?.subCategory))) {
      error = "Required";
      err = {
        ...err,
        subCategory: "Sub-Category Name is Required!",
      };
    }
    if (publishing && (weaveTypeApplicable && (!masterIdFromRef(form?.weaveType)))) {
      error = "Required";
      err = {
        ...err,
        weaveType: "Weave Type is Required!",
      };
    }
    if (form?.productName === "") {
      error = "Required";
      err = {
        ...err,
        product: "Product Name is Required!",
      };
    }
    if (form?.variantCode === "") {
      error = "Required";
      setError({
        ...Error,
      });
      err = {
        ...err,
        variantCode: "Color Name is Required!",
      };
    }
    setError(err);
    return error;
  };
  const handleOnInputChangeFilters = (type: any) => {
    if (type?.name === "productFilter") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "designing") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "weaving") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "dying") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "finishing") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "artform") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
      if (
        type?.value.length === 0 &&
        !form?.artform?.value &&
        !form?.type?.value &&
        !form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "type") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.artform?.value &&
        !form?.type?.value &&
        !form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
        });
      }
    }
    if (type?.name === "category") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.type?.value &&
        !form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
        });
      }
    }
    if (type?.name === "subCategory") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
        });
      }
    }
    if (type?.name === "weaveType") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
          subCategory: form?.subCategory?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
          subCategory: form?.subCategory?.value,
        });
      }
    }
  };
  const s3UploadDesigningBatch = async (files: File[]) => {
    const out: { status: number; url: string }[] = [];
    for (let i = 0; i < files.length; i++) {
      let fileType: any = files[i]?.type;
      if (
        fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        fileType = "application/docx";
      } else if (fileType === "application/msword") {
        fileType = "application/doc";
      }
      await new Promise<void>((resolve) => {
        props.fetchProductDesigningPresignedUrl({ fileType }, (res: any) => {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", files[i].type);
          props.uploadImages1(res.data, files[i], myHeaders, (resServer: any) => {
            const st = resServer?.status;
            out.push({
              status: st,
              url: (resServer?.url || "").split("?")[0],
            });
            allStatusCodes.push(st);
            resolve();
          });
        });
      });
    }
    return out;
  };

  const onFlexFilesPicked = (slotKey: string, files: File[]) => {
    const added: any[] = [];
    files.forEach((file) => {
      added.push({
        type: file.type,
        blobImage: URL.createObjectURL(file),
        fileName: file.name,
        show: true,
        _local: true,
        uploadStatus: "QUEUED",
        uploadProgress: 0,
      });
      void enqueueProductMedia({
        file,
        productId: "",
        section: "flexible",
        processTitle: "",
      }).then((job) => {
        if (!job) {
          return;
        }
        setForm((f: any) => ({
          ...f,
          flexUploadSlots: f.flexUploadSlots.map((s: any) => {
            if (s.key !== slotKey) return s;
            return {
              ...s,
              baseImages: (s.baseImages || []).map((img: any) =>
                img.fileName === file.name && img._local
                  ? {
                      ...img,
                      mediaId: job.mediaId,
                      uploadStatus: job.status,
                    }
                  : img
              ),
            };
          }),
        }));
      });
    });
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: f.flexUploadSlots.map((s: any) => {
        if (s.key !== slotKey) return s;
        return { ...s, baseImages: [...(s.baseImages || []), ...added] };
      }),
    }));
  };

  const onFlexDeletePreview = (slotKey: string, index: number) => {
    onFlexDeleteMany(slotKey, [index]);
  };

  const onFlexDeleteMany = (slotKey: string, indexes: number[]) => {
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: f.flexUploadSlots.map((s: any) => {
        if (s.key !== slotKey) return s;
        const removed = mediaItemsAtVisibleIndexes(s.baseImages, indexes);
        const nextImgs = dropMediaItems(s.baseImages, removed);
        const localNames = removed
          .filter((item: any) => item?._local && item.fileName)
          .map((item: any) => item.fileName);
        if (localNames.length) {
          setFlexPendingFiles((prev) => ({
            ...prev,
            [slotKey]: (prev[slotKey] || []).filter((file) => !localNames.includes(file.name)),
          }));
        }
        return { ...s, baseImages: nextImgs };
      }),
    }));
  };

  const onFlexToggleShow = (slotKey: string, index: number, show: boolean) => {
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: f.flexUploadSlots.map((s: any) => {
        if (s.key !== slotKey) return s;
        const imgs = [...s.baseImages];
        if (imgs[index]) imgs[index] = { ...imgs[index], show };
        return { ...s, baseImages: imgs };
      }),
    }));
  };

  const handleSubmit = async (data: any) => {
    let result: any = validate(data?.status === 1);
    if (result?.length > 0) {
      // Open the step that holds the first red field, then take the user to it.
      setLevelsOpen(true);
      window.setTimeout(() => {
        const first = document.querySelector(".RequiredField");
        const holder = stepOfElement(first);
        if (holder && holder !== step) setStep(holder);
        window.setTimeout(() => first?.scrollIntoView({ block: "center" }), 50);
      }, 150);
      notifications({
        title: "Fill the required fields",
        message: "Some required fields are empty. They are marked in red.",
        type: "danger",
      });
      return;
    }
    if (result?.length === 0) {
      if (submittingRef.current) return;
      submittingRef.current = true;
      setSaving(data?.status === 1 ? "publish" : "save");
      try {
        await submitValidated(data);
      } catch (e) {
        releaseSubmit();
        throw e;
      }
    }
  };
  // Runs with submittingRef held. Every path that doesn't reach callingCreateProduct must release it.
  const submitValidated = async (data: any) => {
    if (data?.status === 1) {
      const [productRes, processRes] = await Promise.all([
        getOrganizationTaxonomyConfig("PRODUCT"), getOrganizationTaxonomyConfig("PROCESS"),
      ]);
      if (productRes.success) setProductTaxonomyFields(productRes.data || []);
      if (processRes.success) setProcessTaxonomyFields(processRes.data || []);
      const missing = productRes.success && processRes.success
        ? collectMissingPublishFields(productRes.data || [], form?.taxonomyValues,
            processRes.data || [], form.flexUploadSlots || [], processMasterOptions)
        : [];
      if (!productRes.success || !processRes.success) setTaxonomyConfigError(customFieldsCopy.configLoadWarning);
      if (missing.length) {
        setMissingPublishFields(missing);
        const first = document.getElementById("hkp-product-attributes");
        first?.scrollIntoView({ behavior: "smooth", block: "start" });
        releaseSubmit();
        return;
      }
    }
    setMissingPublishFields([]);
    if (summarizeUploads("", visibleMediaIds).unresolved > 0) {
      notifications({
        title: "Uploads in progress",
        message: "Wait for media uploads to finish before saving.",
        type: "danger",
      });
      releaseSubmit();
      return;
    }
    let flexSlots = JSON.parse(JSON.stringify(form.flexUploadSlots || []));
    const thumbnailMedia = persistableThumbnailRows(baseImageLogo);
    setForm((current: any) => ({ ...current, flexUploadSlots: flexSlots }));

    const flexPayload = flexSlotsToPayloadProcesses(flexSlots);
    const pickMedia = (i: number) => {
      const m = flexPayload[i]?.media;
      return m?.length ? m : [{ mediaUrl: "", show: 0 }];
    };
    const pickKarigar = (i: number) => masterIdFromRef(flexSlots[i]?.artisan);
    // if (selectedFileVariant?.length > 0) {
    //   // setLoader({ ...loader, variants: true });
    //   setLoader(true);

    //   const resultForVariants: any = await S3UploadVariants();
    //   resultForVariants.forEach((ele: any) => {
    //     promiseVariantStatusCode.push(ele?.statusCode);
    //     allStatusCodes.push(ele?.statusCode);
    //     if (ele?.statusCode === 200) {
    //       promiseVariantUrl.push(ele?.url);
    //     }
    //   });
    //   promiseVariantStatusCode.map((ele: any, i: any) => {
    //     if (ele === 200) {
    //     } else {
    //       notifications({
    //         title: "Error!",
    //         message: `File ${i + 1} upload failed`,
    //         type: "danger",
    //       });
    //     }
    //   });
    //   setLoader(false);

    //   // setLoader({ ...loader, variants: false });
    // }
    let payload: any = {
      mediaViewsSkipped: normalizeSkipped(form?.mediaViewsSkipped),
      name: form?.productName,
      tags: form?.tags,
      ...(Array.isArray(form?.typeTagIds) ? { typeTagIds: form.typeTagIds } : {}),
      xuid: form?.xuid?.length ? form?.xuid.trim() : "",
      thumbnails: {
        media: mediaForProductWrite(
          thumbnailMedia.length ? thumbnailMedia : [{ mediaUrl: "", show: 0, pin: 0 }],
          true
        ),
      },
      // thumbnailDetails: { media: promiseLogoUrl ? promiseLogoUrl : [] },
      artformId: form?.artform?.value,
      typeId: form?.type?.value,
      categoryId: form?.category?.value,
      subcategoryId: form?.subCategory?.value,
      weavetypeId: form?.weaveType?.value,
      // associationId: "",
      designing: {
        media: mediaForProductWrite(pickMedia(0)),
        karigarId: pickKarigar(0),
      },
      weaving: {
        media: mediaForProductWrite(pickMedia(1)),
        karigarId: pickKarigar(1),
      },
      dying: {
        media: mediaForProductWrite(pickMedia(2)),
        karigarId: pickKarigar(2),
      },
      finishing: {
        media: mediaForProductWrite(pickMedia(3)),
        karigarId: pickKarigar(3),
      },
      status: data?.status,
      color: form?.variantCode,
      description: form?.description || "",
      additionalImages: promiseVariantUrl ? promiseVariantUrl : [],
      brand: form?.nameOfBrand,
      weaver: form?.nameOfWeaver,
      handloom: form?.handloomMark,
      silk: form?.silkMark,
      zari: form?.zariUsed?.label,
      sareeWeight: form?.weightOfSaree,
      zariWeight: form?.weightOfZariUsed,
      purity: form?.zariUsed?.value,
      madeIn: "true",
      yarnType: form?.yarnType?.label ? form?.yarnType?.label : "",
      workingHours: form?.workingHours,
      loomNum: form?.loomNum,
      // new
      srNo: form?.SrNo,
      orgSrNo: parseOrgSrNo(form?.orgSrNo),
      weavingCenter: form?.weavingCenter,
      giId: form?.giId || undefined,
      typeOfSareeByDesign: form?.typeOfSareeByDesign?.label,
      productionTimeInMonths: form?.productionTimeInMonths?.label,
      sellPrice: form?.sellPrice,
      costPrice: form?.costPrice,
      inStock: data?.status === 1,
      designNum: form?.designNum,
      parentId:form?.parentId,
      processSteps: serializeProcessStepsForApi(form?.processSteps),
      processWorkflowVersion: "flexible",
      flexibleUploadProcesses: flexPayload.map((process: any) => ({
        ...process,
        media: mediaForProductWrite(process.media),
      })),
      studioOrderId: form?.studioOrderId || undefined,
      studioOrderCode: form?.studioOrderCode || undefined,
      taxonomyValues: mergeTaxonomyValues(
        form?.taxonomyValues,
        form?.taxonomyValues,
        productTaxonomyFields.map((field) => field.taxonomyId)
      ),
    };
    const uploadHadFailures =
      allStatusCodes.length > 0 && !allStatusCodes.every((ele: any) => ele === 200);
    if (uploadHadFailures) {
      callingCreateProduct(payload, "Kindly edit and add the media again !");
    } else {
      callingCreateProduct(payload);
    }
  };
  const handleOnInputChange = (type: any) => {
    setHandleNameFlag({
      designing: false,
      weaving: false,
      dying: false,
      finishing: false,
    });
    let formValues = form;
    if (type?.name === "artform") {
      formValues = {
        ...formValues,
        type: "",
        category: "",
        subCategory: "",
        weaveType: "",
        artform: type?.value,
      };
    } else if (type?.name === "type") {
      formValues = {
        ...formValues,
        type: type?.value,
        category: "",
        subCategory: "",
        weaveType: "",
      };
    } else if (type?.name === "category") {
      formValues = {
        ...formValues,
        category: type?.value,
        subCategory: "",
        weaveType: "",
      };
    } else if (type?.name === "subCategory") {
      formValues = {
        ...formValues,
        subCategory: type?.value,
        weaveType: "",
      };
    } else if (type?.name === "weaveType") {
      formValues = {
        ...formValues,
        weaveType: type?.value,
      };
    }  
    else {
      if (
        authUser?.users?.organizationResponse?.name ===
        "tantuvi by smriti morarka" &&
        type?.name === "typeOfSareeByDesign"
      ) {
        formValues = {
          ...formValues,
          productName: type?.value?.value,
          typeOfSareeByDesign: type?.value,
        };
      } else if (type?.name === "timeTakenInMonths") {
        formValues = {
          ...formValues,
          workingHours: type?.value?.value,
          productionTimeInMonths: type?.value,
        };
      } else {
        formValues = {
          ...formValues,
          [type.name]: type?.value,
        };
      }
    }
    setForm(formValues);
    setFilterValue({
      type: "",
      category: "",
      subCategory: "",
      weaveType: "",
    });
  };
  const gettingFileType = (file: any) => {
    let fileType: any;
    if (
      file ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      fileType = "application/docx";
    } else if (file === "application/msword") {
      fileType = "application/doc";
    } else {
      fileType = file;
    }
    return fileType;
  };
  // S3 upload into awd
  // const S3UploadVariants = async () => {
  //   let softCopyArry: any = [];
  //   for (let i = 0; i < selectedFileVariant?.length; i++) {
  //     let fileType: any;
  //     fileType = gettingFileType(selectedFileVariant[i]?.type);
  //     const promise = new Promise((resolve: any, reject: any) => {
  //       props.fetchProductDesigningPresignedUrl(
  //         { fileType: fileType },
  //         (res: any) => {
  //           const formData = new FormData();
  //           formData.append(
  //             selectedFileVariant[i],
  //             selectedFileVariant[i].name
  //           );
  //           const myHeaders = new Headers();
  //           myHeaders.append("Content-Type", selectedFileVariant[i].type);
  //           props.uploadImages1(
  //             res.data,
  //             selectedFileVariant[i],
  //             myHeaders,
  //             (resSerever: any) => {
  //               softCopyArry.push({
  //                 statusCode: resSerever?.status,
  //                 url: resSerever?.url.split("?")[0],
  //               });
  //               resolve(softCopyArry);
  //             }
  //           );
  //         }
  //       );
  //     });
  //     promiseForVariant.push(promise);
  //   }
  //   let t: any = [];
  //   t = await Promise.all(promiseForVariant);
  //   return t[0];
  // };
  const S3UploadFinishing = async () => {
    let softCopyArryFinishing: any = [];
    let status: any = [];
    for (let i = 0; i < selectedFileFinisher?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileFinisher[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductFinishingPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(
              selectedFileFinisher[i],
              selectedFileFinisher[i].name
            );
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileFinisher[i].type);
            props.uploadImages1(
              res.data,
              selectedFileFinisher[i],
              myHeaders,
              (resSerever: any) => {
                status.push(resSerever?.status);
                softCopyArryFinishing.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArryFinishing);
              }
            );
          }
        );
      });
      promiseForFinishing.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForFinishing);
    return t[0];
  };
  const S3UploadWeaving = async () => {
    let softCopyArryWeaving: any = [];
    for (let i = 0; i < selectedFileWeaver?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileWeaver[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductWeavingPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(selectedFileWeaver[i], selectedFileWeaver[i].name);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileWeaver[i].type);
            props.uploadImages1(
              res.data,
              selectedFileWeaver[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArryWeaving.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArryWeaving);
              }
            );
          }
        );
      });
      promiseForWeaving.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForWeaving);
    return t[0];
  };
  const S3UploadForLogo = async (files?: File[]) => {
    const toUpload = collectUniqueFiles([], files || selectedFile || []);
    promiseForLogo = [];
    const softCopyArry: { statusCode?: number; url?: string }[] = new Array(toUpload.length);

    await Promise.all(
      toUpload.map(
        (file, i) =>
          new Promise<void>((resolve) => {
            const fileType = gettingFileType(file.type);
            props.fetchProfilePresignedUrl({ fileType: fileType }, (res: any) => {
              const myHeaders = new Headers();
              myHeaders.append("Content-Type", file.type);
              props.uploadImages1(res.data, file, myHeaders, (resSerever: any) => {
                softCopyArry[i] = {
                  statusCode: resSerever?.status,
                  url: (resSerever?.url || "").split("?")[0],
                };
                resolve();
              });
            });
          })
      )
    );
    return softCopyArry;
  };
  const S3UploadDesigner = async () => {
    let softCopyArry: any = [];

    for (let i = 0; i < selectedFileDesigner?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileDesigner[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductDesigningPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(
              selectedFileDesigner[i],
              selectedFileDesigner[i].name
            );
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileDesigner[i].type);
            props.uploadImages1(
              res.data,
              selectedFileDesigner[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArry.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArry);
              }
            );
          }
        );
      });
      promiseForDesign.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForDesign);
    return t[0];
  };
  const S3UploadDying = async () => {
    let softCopyArryForDying: any = [];
    for (let i = 0; i < selectedFileDying?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileDying[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductDyingPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(selectedFileDying[i], selectedFileDying[i].name);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileDying[i].type);
            props.uploadImages1(
              res.data,
              selectedFileDying[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArryForDying.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArryForDying);
              }
            );
          }
        );
      });
      promiseForDying.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForDying);
    return t[0];
  };

  // file upload method start reuseable function
  const uploadFiles = (data: any) => {
    let { fileObject, name, files, view } = data;
    if (!files?.length) {
      return;
    }
    const uniqueArr = collectUniqueFiles(fileObject, files);
    uploadImageArray({
      name,
      uniqueArr,
      view,
    });
    if (name === "designing") {
      setSelectedFileDesigner(uniqueArr);
      fileObjDesign = uniqueArr;
    } else if (name === "dying") {
      setSelectedFileDying(uniqueArr);
      fileObjDying = uniqueArr;
    } else if (name === "weaving") {
      setSelectedFileWeaver(uniqueArr);
      fileObjWeaving = uniqueArr;
    } else if (name === "finishing") {
      setSelectedFileFinisher(uniqueArr);
      fileObjFinishing = uniqueArr;
    } else if (name === "variant") {
      setSelectedFileVariant(uniqueArr);
      fileObjVariant = uniqueArr;
    } else if (name === "logo") {
      setSelectedFile(uniqueArr);
      fileObjLogo = uniqueArr;
      uniqueArr.forEach((file: File) => {
        void enqueueProductMedia({
          file,
          productId: "",
          section: "thumbnail",
          show: 1,
          view: view || null,
        }).then((job) => {
          if (!job) {
            return;
          }
          setBaseImageLogo((prev: any[]) =>
            (prev || []).map((img: any) =>
              img.fileName === file.name && img._local && !img.mediaId
                ? { ...img, mediaId: job.mediaId, uploadStatus: job.status }
                : img
            )
          );
        });
      });
    }
  };
  // base image reuseable function
  const uploadImageArray = async (data: any) => {
    let { name, uniqueArr, view } = data;
    const current =
      name === "designing"
        ? baseImageDesigner
        : name === "dying"
          ? baseImageDying
          : name === "weaving"
            ? baseImageWeaver
            : name === "finishing"
              ? baseImageFinisher
              : name === "variant"
                ? baseImageVariant
                : baseImageLogo;
    const merged = mergePersistedWithLocalPreviews(
      current,
      uniqueArr,
      name === "logo" ? { pin: false, uploadStatus: "QUEUED", view: view || null } : undefined
    );
    if (name === "designing") {
      setBaseImageDesigner(merged);
    } else if (name === "dying") {
      setBaseImageDying(merged);
    } else if (name === "weaving") {
      setBaseImageWeaver(merged);
    } else if (name === "finishing") {
      setBaseImageFinisher(merged);
    } else if (name === "variant") {
      setBaseImageVariant(merged);
    } else if (name === "logo") {
      setBaseImageLogo(merged);
    }
  };
  // logo file upload function

  const uploadImage = async (e: any) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImageLogo(base64);
  };
  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const addChip = (value: any) => {
    const chips = form.tags.slice();
    chips.push(value);
    setForm({
      ...form,
      tags: chips,
    });
  };
  const removeChip = (index: any) => {
    const chips = form.tags.slice();
    chips.splice(index, 1);
    setForm({
      ...form,
      tags: chips,
    });
  };
  const handleDeleteFinisher = (i: any, item: any) => {
    setDeleteIndexFinisher({
      i,
      item,
    });
  };
  const handleDeleteWeaver = (i: any, item: any) => {
    setDeleteIndexWeaver({
      i,
      item,
    });
  };
  const handleDeleteDying = (i: any, item: any) => {
    setDeleteIndexDying({
      i,
      item,
    });
  };
  const handleDeleteDesigner = (i: any, item: any) => {
    setDeleteIndexDesigner({
      i,
      item,
    });
  };

  const handleDeleteLogo = (i: any, item: any) => {
    if (item?.mediaId) void cancelProductMedia(item.mediaId);
    setDeleteIndexLogo({
      i,
      item,
    });
  };
  const handleDeleteVariant = (i: any, item: any) => {
    setDeleteIndexVariant({
      i,
      item,
    });
  };

  const handleChangeDebounce = React.useCallback(
    debounce((data: any) => {
      if (data?.name === "productFilter") {
        CallingGettProductForFilter(data);
      }
      if (data?.name === "product") {
        CallingGettProduct(data);
      }
      if (data?.name === "artform") {
        getArtformData(data?.value);
      }
      if (data?.name === "type") {
        getTypesData(data);
      }
      if (data?.name === "category") {
        getCategoryData(data);
      }
      if (data?.name === "subCategory") {
        getSubCategoryData(data);
      }
      if (data?.name === "weaveType") {
        getWeaveTypeData(data);
      }
      if (data?.name === "designing") {
        getCreatorsDataDesignerOption(data?.value);
      }
      if (data?.name === "weaving") {
        getCreatorsDataWeaverOption(data?.value);
      }
      if (data?.name === "dying") {
        getCreatorsDataDyingOption(data?.value);
      }
      if (data?.name === "finishing") {
        getCreatorsDataFinishingOption(data?.value);
      }
    }, 1000),
    []
  );
  const closeModal = () => {
    setOpenModal({
      artform: false,
      type: false,
      category: false,
      subCategory: false,
      weaveType: false,
      designing: false,
      dying: false,
      weaving: false,
      finishing: false,
    });
  };
  const callingGetTypesData = (value: any) => {
    props.getTypes(
      {
        offset: 0,
        limit: 1,
        artFormId: value?.artformId,
        typeName: value?.type,
      },
      (res: any) => {
        // let newValues={...filterValue}
        if (res?.data?.docs?.length) {
          res.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              type: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              type: ele?._id,
            });
          });
        }
      }
    );
  };
  const callingGetCategoryData = (value: any) => {
    props.getCategory(
      {
        offset: 0,
        limit: 10,
        typeId: value?.typeId,
        categoryName: value?.category,
        artformId: value?.artformId,
      },
      (res: any) => {
        if (res?.data?.docs?.length) {
          res?.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              category: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              category: ele?._id,
            });
          });
        }
      }
    );
  };
  const callingGetSubCategory = (value: any) => {
    props.getSubCategorys(
      {
        offset: 0,
        limit: 1,
        // category:value?.category,
        subCategoryName: value?.subCategory,
        artformId: value?.artformId,
        typeId: value?.typeId,
        categoryId: value?.categoryId,
        subCategoryId: value?.subCategoryId,
      },
      (res: any) => {
        if (res?.data?.docs?.length) {
          res?.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              subCategory: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              subCategory: ele?._id,
            });
          });
        }
      }
    );
  };

  const callingGetWeaveType = (value: any) => {
    props.getWeaveType(
      {
        offset: 0,
        limit: 10,
        artformId: value?.artformId,
        typeId: value?.typeId,
        categoryId: value?.categoryId,
        subCategoryId: value?.subCategoryId,
        weaveTypeId: value?.weaveTypeId,
        weaveTypeName: value.weaveType,
      },
      (res: any) => {
        if (res?.data?.docs?.length) {
          res?.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              weaveType: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              weaveType: ele?._id,
            });
          });
        }
      }
    );
  };
  const handleName = (value: any) => {
    if (value?.name === "artform") {
      props.getArtforms(
        {
          offset: 0,
          limit: 1,
          artformName: value?.artform,
        },
        (res: any) => {
          if (res?.data?.docs?.length) {
            setForm({
              ...form,
              artform: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
          }
        }
      );
    }
    if (value?.name === "type") {
      callingGetTypesData({
        artformId: value?.artform,
        type: value?.type,
      });
    }
    if (value?.name === "category") {
      callingGetCategoryData({
        typeId: value?.type,
        category: value?.category,
      });
    }
    if (value?.name === "subCategory") {
      callingGetSubCategory({
        categoryId: value?.category,
        subCategory: value?.subCategory,
      });
    }
    if (value?.name === "weaveType") {
      callingGetWeaveType({
        subCategoryId: value?.subCategory,
        weaveType: value?.weaveType,
      });
    }
    let flag = handleNameFlag;
    if (value.name === "designing") {
      getCreatorsData({
        userId: value?.userId,
        name: "designing",
      });
      flag = {
        ...flag,
        designing: true,
      };
    }
    if (value.name === "weaving") {
      getCreatorsData({
        userId: value?.userId,
        name: "weaving",
      });
      flag = {
        ...flag,
        weaving: true,
      };
    }
    if (value.name === "dying") {
      getCreatorsData({
        userId: value?.userId,
        name: "dying",
      });
      flag = {
        ...flag,
        dying: true,
      };
    }
    if (value.name === "finishing") {
      getCreatorsData({
        userId: value?.userId,
        name: "finishing",
      });
      flag = {
        ...flag,
        finishing: true,
      };
    }
    setHandleNameFlag(flag);
  };
  const handleOpenArtform = () => {
    setOpenModal({
      artform: true,
    });
  };
  const handleOpenType = () => {
    setOpenModal({
      type: true,
    });
  };
  const handleOpenCategory = () => {
    setOpenModal({
      category: true,
    });
  };
  const handleOpenSubCategory = () => {
    setOpenModal({
      subCategory: true,
    });
  };
  const handleOpenWeaveType = () => {
    setOpenModal({
      weaveType: true,
    });
  };
  const handleOpenModal = (value: any) => {
    setOpenModal({
      [value?.name]: value?.value,
    });
  };
  const onSetIndexDesign = (type: any) => {
    if (type?.name === "designing") {
      setBaseIndex({
        designing: type,
      });
    }
    if (type?.name === "weaving") {
      setBaseIndex({
        weaving: type,
      });
    }
    if (type?.name === "dying") {
      setBaseIndex({
        dying: type,
      });
    }
    if (type?.name === "finishing") {
      setBaseIndex({
        finishing: type,
      });
    }
    if (type?.name === "logo") {
      setBaseIndex({
        logo: type,
      });
    }
  };
  /** Tag a photo with its view; a saved draft row is patched right away, local rows carry it to the save. */
  const onSetPhotoView = (index: number, view: string | null) => {
    // Add has no saved product yet: the view rides on the upload job and the save payload.
    setBaseImageLogo((prev: any[]) =>
      (prev || []).map((img: any, i: number) => (i === index ? { ...img, view: view || undefined } : img))
    );
  };
  /** "This piece has no blouse": a studio hint saved with the product, never shown to buyers. */
  const onSkipPhotoView = (view: string, skipped: boolean) => {
    setForm((f: any) => {
      const current: string[] = Array.isArray(f?.mediaViewsSkipped) ? f.mediaViewsSkipped : [];
      return {
        ...f,
        mediaViewsSkipped: skipped ? Array.from(new Set([...current, view])) : current.filter((v) => v !== view),
      };
    });
  };
  const onSetPin = (type: any) => {
    setBaseIndexForLogo(type);
  };
  useEffect(() => {
    // if (baseindexForLogo?.length) {
    if (baseImageLogo?.length) {
      let arrayPin: any = [];
      let arrayUnpin: any = [];
      let arrayPinSelected: any = [];
      let arrayUnpinSelected: any = [];
      // After "Continue where you left off" the photos come from the device copy, not this session's picks.
      (Array.isArray(selectedFile) ? selectedFile : []).find((ele: any, i: any) => {
        if (i === baseindexForLogo?.index) {
          arrayPinSelected.push(ele);
        } else {
          arrayPinSelected.push(ele);
        }
        setSelectedFile([...arrayPinSelected]);
      });
      baseImageLogo.find((ele: any, i: any) => {
        if (i === baseindexForLogo?.index) {
          arrayPin.push({
            // Keep the upload id, stored link and asset id; only show/pin change.
            ...ele,
            type: ele?.type,
            blobImage: ele?.blobImage,
            fileName: ele?.fileName,
            show: ele?.show,
            pin: true,
          });
        } else {
          arrayPin.push({
            // Keep the upload id, stored link and asset id; only show/pin change.
            ...ele,
            type: ele?.type,
            blobImage: ele?.blobImage,
            fileName: ele?.fileName,
            show: ele?.show,
            pin: false,
          });
        }
        setBaseImageLogo([...arrayPin]);
      });
    }
    // }
  }, [baseindexForLogo]);
  useEffect(() => {
    if (baseindex?.finishing) {
      if (baseImageFinisher?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageFinisher[baseindex?.finishing?.index],
          type: baseImageFinisher[baseindex?.finishing?.index]?.type,
          blobImage: baseImageFinisher[baseindex?.finishing?.index]?.blobImage,
          fileName: baseImageFinisher[baseindex?.finishing?.index]?.fileName,
          show: baseindex?.finishing?.show,
        };
        baseImageFinisher.find((ele: any, i: any) => {
          if (i === baseindex?.finishing?.index) {
            let showm = [...baseImageFinisher];
            showm[i] = showImageData;
            setBaseImageFinisher([...showm]);
          }
        });
      }
    }
    if (baseindex?.dying) {
      if (baseImageDying?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageDying[baseindex?.dying?.index],
          type: baseImageDying[baseindex?.dying?.index]?.type,
          blobImage: baseImageDying[baseindex?.dying?.index]?.blobImage,
          fileName: baseImageDying[baseindex?.dying?.index]?.fileName,
          show: baseindex?.dying?.show,
        };
        baseImageDying.find((ele: any, i: any) => {
          if (i === baseindex?.dying?.index) {
            let showm = [...baseImageDying];
            showm[i] = showImageData;
            setBaseImageDying([...showm]);
          }
        });
      }
    }
    if (baseindex?.weaving) {
      if (baseImageWeaver?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageWeaver[baseindex?.weaving?.index],
          type: baseImageWeaver[baseindex?.weaving?.index]?.type,
          blobImage: baseImageWeaver[baseindex?.weaving?.index]?.blobImage,
          fileName: baseImageWeaver[baseindex?.weaving?.index]?.fileName,
          show: baseindex?.weaving?.show,
        };
        baseImageWeaver.find((ele: any, i: any) => {
          if (i === baseindex?.weaving?.index) {
            let showm = [...baseImageWeaver];
            showm[i] = showImageData;
            setBaseImageWeaver([...showm]);
          }
        });
      }
    }
    if (baseindex?.designing) {
      if (baseImageDesigner?.length) {
        let showImageData = {
          // ...baseImageDesigner,
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageDesigner[baseindex?.designing?.index],
          type: baseImageDesigner[baseindex?.designing?.index]?.type,
          blobImage: baseImageDesigner[baseindex?.designing?.index]?.blobImage,
          fileName: baseImageDesigner[baseindex?.designing?.index]?.fileName,
          show: baseindex?.designing?.show,
        };
        baseImageDesigner.find((ele: any, i: any) => {
          if (i === baseindex?.designing?.index) {
            let showm = [...baseImageDesigner];
            showm[i] = showImageData;
            setBaseImageDesigner([...showm]);
          }
        });
      }
    }
    if (baseindex?.logo) {
      if (baseImageLogo?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageLogo[baseindex?.logo?.index],
          type: baseImageLogo[baseindex?.logo?.index]?.type,
          blobImage: baseImageLogo[baseindex?.logo?.index]?.blobImage,
          fileName: baseImageLogo[baseindex?.logo?.index]?.fileName,
          show: baseindex?.logo?.show,
          pin: baseImageLogo[baseindex?.logo?.index]?.pin,
        };
        baseImageLogo.find((ele: any, i: any) => {
          if (i === baseindex?.logo?.index) {
            let showm = [...baseImageLogo];
            showm[i] = showImageData;
            setBaseImageLogo([...showm]);
          }
        });
      }
    }
  }, [baseindex]);
  const handleOnchangeProductFilter = (type: any) => {
    let data = type?.value?.value;
    if (type?.name === "productFilter") {
      setSelectedProduct(type?.value);
      setForm({
        ...form,
        artform: {
          label: data?.artform?.name,
          value: data?.artform?._id,
        },
        type: {
          label: data?.type?.name,
          value: data?.type?._id,
        },
        category: {
          label: data?.category?.name,
          value: data?.category?._id,
        },
        subCategory: {
          label: data?.subCategory?.name,
          value: data?.subCategory?._id,
        },
        weaveType: {
          label: data?.weaveType?.name,
          value: data?.weaveType?._id,
        },
        productName: data?.productName,
        tags: data?.tags,
        parentId:data?.parentId
      });
    }
  };
  const handleResetData = () => {
    setForm({
      artform: "",
      type: "",
      category: "",
      subCategory: "",
      weaveType: "",
      productName: "",
      designer: "",
      designerMedia: [],
      weaver: "",
      weaverMedia: [],
      dyer: "",
      dyerMedia: [],
      finisher: "",
      finisherMedia: [],
      profileURL: "",
      tags: [],
      singleTag: "",
      variantCode: "",
      description: "",
      variantImages: [],
      processSteps: [],
      flexUploadSlots: defaultLegacyFlexSlots(),
      SrNo: "",
      xuid: "",
      xuidFromRegistry: false,
      orgSrNo: "",
      parentId: "",
    });
    setFlexPendingFiles({});
    setSelectedProduct("");
    setSwitchButton(false);
    const params = new URLSearchParams(location.search || "");
    setForm((current: any) => ({
      ...current,
      studioOrderId: params.get("orderId") || "",
      studioOrderCode: params.get("orderCode") || "",
    }));
    assignNextOrgSrNo(true);
  };
  const handleReset = (type: any) => {
    if (type?.name === "designing") {
      setForm({
        ...form,
        designer: "",
      });
    }
    if (type?.name === "weaving") {
      setForm({
        ...form,
        weaver: "",
      });
    }
    if (type?.name === "dying") {
      setForm({
        ...form,
        dyer: "",
      });
    }
    if (type?.name === "finishing") {
      setForm({
        ...form,
        finisher: "",
      });
    }
  };
  // create variant — copy details and family/order, never copy identity
  useEffect(() => {
    if (location?.state?.name !== "variant" || !location?.state?.productDetails) {
      return;
    }
    let cancelled = false;
    const editDetails = location.state.productDetails;
    fetchNextOrgSrNo().then((nextSn) => {
      setVariantPrefilled(true);
      if (cancelled) {
        return;
      }
      setForm({
          artform: {
            value: editDetails?.artform?._id,
            label: editDetails?.artform?.name,
          },
          type: {
            value: editDetails?.type?._id,
            label: editDetails?.type?.name,
          },
          category: {
            value: editDetails?.category?._id,
            label: editDetails?.category?.name,
          },
          subCategory: {
            value: editDetails?.subcategory?._id,
            label: editDetails?.subcategory?.name,
          },
          weaveType: {
            value: editDetails?.weavetype?._id,
            label: editDetails?.weavetype?.name,
          },
          productName: editDetails?.name,
          designer:
            editDetails?.designingDetails?.karigar?.name?.length > 0
              ? {
                label: editDetails?.designingDetails?.karigar?.name,
                value: editDetails?.designingDetails?.karigar?._id,
              }
              : "",

          weaver:
            editDetails?.weavingDetails?.karigar?.name?.length > 0
              ? {
                label: editDetails?.weavingDetails?.karigar?.name,
                value: editDetails?.weavingDetails?.karigar?._id,
              }
              : "",

          dyer:
            editDetails?.dyingDetails?.karigar?.name?.length > 0
              ? {
                label: editDetails?.dyingDetails?.karigar?.name,
                value: editDetails?.dyingDetails?.karigar?._id,
              }
              : "",

          finisher:
            editDetails?.finishingDetails?.karigar?.name?.length > 0
              ? {
                label: editDetails?.finishingDetails?.karigar?.name,
                value: editDetails?.finishingDetails?.karigar?._id,
              }
              : "",

          productOwner: editDetails?.productOwner,
          tags: editDetails?.tags ? editDetails?.tags : [],
          status: editDetails.status,
          variantCode: editDetails?.color,
          description: editDetails?.description || "",
          //new
          nameOfBrand: editDetails?.brand,
          nameOfWeaver: editDetails?.weaver,
          handloomMark: editDetails?.handloom,
          silkMark: editDetails?.silk,
          zariUsed: { label: editDetails?.zari, value: editDetails?.purity },
          weightOfSaree: editDetails?.sareeWeight,
          weightOfZariUsed: editDetails?.zariWeight,
          purity: editDetails?.purity,
          madeInIndia: true,
          yarnType: editDetails?.yarnType
            ? {
              label: editDetails?.yarnType,
              value: editDetails?.yarnType,
            }
            : "",
          workingHours: editDetails?.workingHours,
          loomNum: editDetails?.loomNum,
          xuid: "",
          xuidFromRegistry: false,
          parentId: editDetails?.parentId || editDetails?.productUniqueId || "",
          SrNo: "",
          orgSrNo: nextSn != null ? nextSn : "",
          weavingCenter: editDetails?.weavingCenter || form?.weavingCenter,
          giId: editDetails?.giId || "",
          typeOfSareeByDesign: editDetails?.typeOfSareeByDesign
            ? {
              label: editDetails?.typeOfSareeByDesign,
              value: editDetails?.name,
            }
            : "",
          // No saved time → no value, so the picker shows "Select" instead of an empty box.
          productionTimeInMonths: editDetails?.productionTimeInMonths
            ? {
                label: editDetails?.productionTimeInMonths,
                value: editDetails?.workingHours,
              }
            : "",
          sellPrice: editDetails?.sellPrice,
          costPrice: editDetails?.costPrice,
          designNum: editDetails?.designNum,
          processSteps: parseProcessStepsFromApi(editDetails?.processSteps),
          flexUploadSlots: buildFlexSlotsFromProduct(editDetails, baseImageCovert),
          studioOrderId: editDetails?.studioOrderId || form?.studioOrderId || "",
          studioOrderCode: editDetails?.studioOrderCode || form?.studioOrderCode || "",
        });
    });
    return () => {
      cancelled = true;
    };
  }, [location?.state?.name === "variant"]);

  // Phones lose a half-filled form easily (back swipe, menu tap, reload), so warn before leaving.
  // Only after the user has typed or picked something: a variant pre-fills these fields itself.
  // Typing and select picks are caught below; button-only picks (colour chips, category path,
  // Write from photos) call setUserEdited themselves.
  const [userEdited, setUserEdited] = useState(false);
  // A variant fills the whole form from its parent once the next SN is known; Continue waits for that,
  // or the prefill would replace what the device copy just restored.
  const [variantPrefilled, setVariantPrefilled] = useState(!isVariant);
  // Device copy until the server draft exists (see addDraftLocal). While the "Continue?" card is up we
  // must not overwrite the copy it offers, so autosave waits for the choice.
  // A variant's copy belongs to its parent; without the parent's id there is no safe key, so no copy.
  const variantParentId = String(location?.state?.productDetails?._id || location?.state?.productDetails?.productUniqueId || "");
  const localDraftKey = isVariant && !variantParentId ? "" : addDraftKey(currentUploadOwnerKey(), isVariant ? variantParentId : "");
  const [resumeOffer, setResumeOffer] = useState<AddDraftSnapshot | null>(() => loadAddDraft(localDraftKey));
  useEffect(() => {
    if (resumeOffer || !userEdited || savedRef.current) return undefined;
    const timer = window.setTimeout(() => {
      if (!savedRef.current) saveAddDraft(localDraftKey, buildAddDraft(form, baseImageLogo, step));
    }, 400);
    return () => window.clearTimeout(timer);
  }, [form, baseImageLogo, step, userEdited, resumeOffer, localDraftKey]);
  /**
   * Rows from the device copy: stored ones as they are; rows still uploading get their job back (from this
   * tab's queue, or re-queued from IndexedDB so it actually uploads) with its preview. A row with no stored
   * link and no job left (private mode, or the upload finished after the last copy) can't come back.
   */
  const reviveRows = async (rows: any): Promise<any[]> => {
    const jobs = new Map(getUploadJobs().map((job) => [job.mediaId, job]));
    const out: any[] = [];
    for (const row of Array.isArray(rows) ? rows : []) {
      if (!row) continue;
      if (itemPersistableUrl(row)) {
        out.push(row);
        continue;
      }
      if (!row.mediaId) continue;
      let job = jobs.get(row.mediaId);
      if (!job) {
        const stored = await getUploadJob(row.mediaId).catch(() => undefined);
        if (!stored?.blob) continue;
        await retryProductMedia(row.mediaId);
        job = getUploadJobs().find((j) => j.mediaId === row.mediaId);
        if (!job) continue;
      }
      out.push({ ...row, blobImage: job.storageUrl || job.previewUrl, uploadStatus: job.status, uploadProgress: job.progress, _local: !job.storageUrl });
    }
    return out;
  };
  const continueLocalDraft = async () => {
    const snap = resumeOffer;
    if (!snap) return;
    const photos = await reviveRows(snap.photos);
    // Making (process) media is in the form copy too; it comes back the same way.
    const slots = Array.isArray((snap.form as any)?.flexUploadSlots)
      ? await Promise.all(
          (snap.form as any).flexUploadSlots.map(async (slot: any) => ({ ...slot, baseImages: await reviveRows(slot?.baseImages) }))
        )
      : undefined;
    // This visit's order link, SN and HKP tag win: an old copy must never relink or re-identify a piece.
    const { studioOrderId, studioOrderCode, xuid, xuidFromRegistry, orgSrNo, parentId, status, productUniqueId, ...restored } =
      snap.form as any;
    setResumeOffer(null);
    setSelectedFile([]);
    setForm((current: any) => ({ ...current, ...restored, ...(slots ? { flexUploadSlots: slots } : {}) }));
    setBaseImageLogo(photos);
    setUserEdited(true);
    if (snap.step === "photos" || snap.step === "basics") setStep(snap.step);
  };
  /** Upload jobs only the device copy points at (photos and process media), so nothing uploads for nobody. */
  const copyOnlyJobs = (snap: AddDraftSnapshot | null): string[] => {
    const slots: any[] = Array.isArray((snap?.form as any)?.flexUploadSlots) ? (snap?.form as any).flexUploadSlots : [];
    const rows = [...(snap?.photos || []), ...slots.flatMap((slot: any) => (Array.isArray(slot?.baseImages) ? slot.baseImages : []))];
    return rows.filter((row: any) => row?.mediaId && !itemPersistableUrl(row)).map((row: any) => row.mediaId);
  };
  const discardLocalDraft = () => {
    copyOnlyJobs(resumeOffer).forEach((id) => void cancelProductMedia(id));
    clearAddDraft(localDraftKey);
    setResumeOffer(null);
  };
  useEffect(() => {
    if (userEdited) return undefined;
    const markEdited = () => setUserEdited(true);
    const onPointerDown = (event: PointerEvent) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest?.(".react-select__option, [id*='-option-']")) markEdited();
    };
    // Keyboard picks in a react-select (Enter, Tab, Space) never fire input/change on the page.
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      if (["Enter", "Tab", " "].includes(event.key) && target?.closest?.("[class*='react-select']")) markEdited();
    };
    document.addEventListener("input", markEdited, true);
    document.addEventListener("change", markEdited, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      document.removeEventListener("input", markEdited, true);
      document.removeEventListener("change", markEdited, true);
      document.removeEventListener("pointerdown", onPointerDown, true);
      document.removeEventListener("keydown", onKeyDown, true);
    };
  }, [userEdited]);
  const hasUnsavedWork = userEdited && (
    Boolean(String(form?.productName || "").trim()) ||
    Boolean(String(form?.variantCode || "").trim()) ||
    Boolean(String(form?.description || "").trim()) ||
    Boolean(form?.artform) ||
    (Array.isArray(baseImageLogo) && baseImageLogo.length > 0));
  useEffect(() => {
    if (!hasUnsavedWork) return undefined;
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      if (savedRef.current) return;
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [hasUnsavedWork]);

  const goToStep = (target: ProductStepId) => {
    if (stepIndex(target) > stepIndex("basics")) {
      saveDraftAndContinue(target);
      return;
    }
    setStep(target);
    history.replace({ pathname: location.pathname, search: `?step=${target}`, state: location.state });
    window.scrollTo({ top: 0 });
  };

  // Saves the draft (only name and colour are needed) and continues in Edit, where capture links work.
  const saveDraftAndContinue = (target: ProductStepId) => {
    continueStepRef.current = target;
    handleSubmit({ status: 0 }).finally(() => {
      // Validation stopped it before the request went out: forget where we were heading.
      if (!submittingRef.current && !savedRef.current) continueStepRef.current = null;
    });
  };

  const pickCategoryPath = (path: CategoryPath) => {
    setForm((current: any) => ({
      ...current,
      artform: path.artform,
      type: path.type,
      category: path.category,
      subCategory: path.subCategory,
      weaveType: path.weaveType || "",
    }));
  };

  return (
    <>
      {isPreviewOpen && (
        <ProductImagePreView
          {...props}
          openModal={isPreviewOpen}
          closeModal={() => setIsPreviewOpen(false)}
          images={[previewImage]}
          name="editProduct"
        />
      )}
      <Prompt
        when={hasUnsavedWork}
        message={(next: any) =>
          // Step changes only swap ?step= on this page and keep the form mounted, so they never warn.
          savedRef.current || next?.pathname === location.pathname
            ? true
            : "This product is not saved yet. Leave and lose what you entered?"
        }
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.designing}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"designing"}
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.weaving}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"weaving"}
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.dying}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"dying"}
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.finishing}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"finishing"}
      />
      <ArtformModal
        {...props}
        openModal={openModal?.artform}
        closeModal={closeModal}
        getAllData={getArtformData}
        handleName={handleName}
      />
      <TypeModal
        {...props}
        openModal={openModal?.type}
        form={form}
        closeModal={closeModal}
        getAllData={getTypesData}
        handleName={handleName}
      />
      <CategoryModal
        {...props}
        form={form}
        openModal={openModal?.category}
        closeModal={closeModal}
        getAllData={getCategoryData}
        handleName={handleName}
      />
      <SubCategoryModal
        {...props}
        form={form}
        openModal={openModal?.subCategory}
        closeModal={closeModal}
        getAllData={getSubCategoryData}
        handleName={handleName}
      />
      <WeaveTypeModal
        {...props}
        form={form}
        openModal={openModal?.weaveType}
        closeModal={closeModal}
        getAllData={getWeaveTypeData}
        handleName={handleName}
      />
      {loading ? (
        <div className="LoaderDiv">
          <Loader />
        </div>
      ) : (
        <>
          <div className={`ps-shell${isVariant ? " is-variant" : ""}${resumeOffer ? " is-resume-pending" : ""}`}>
            <ProductStepHeader
              title={isVariant ? "Add colour variant" : "Add product"}
              step={step}
              onStep={goToStep}
              lockedFrom="details"
              chip={<span className="ps-chip ps-chip--draft">Not saved yet</span>}
            />
            {resumeOffer ? (
              <div className="ps-resume" role="status">
                <div className="ps-resume__text">
                  <b>Continue where you left off?</b>
                  <small>
                    {[
                      String(resumeOffer.form?.productName || "").trim() || "Untitled piece",
                      mediaCountWords(resumeOffer.photos),
                      `kept on this phone ${savedAgo(resumeOffer.savedAt)}`,
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </small>
                </div>
                <div className="ps-resume__actions">
                  <StepButton onClick={discardLocalDraft}>Start fresh</StepButton>
                  <StepButton kind="blue" wide onClick={() => void continueLocalDraft()} disabled={!variantPrefilled}>
                    Continue
                  </StepButton>
                </div>
              </div>
            ) : null}
            <main className="ps-main createProduct CreateProductDetails">
              <div className="form">
                <div className="UserDetailsDiv">
                  <ProductStepPanel id="photos" active={step}>
                    {isVariant ? (
                      <p className="ps-note">
                        Making a colour variant of <b>{location?.state?.productDetails?.name || "this product"}</b>.
                        Craft, weave and making are copied. Each piece gets its own SN, HKP tag number and HKP ID.
                      </p>
                    ) : (
                      <DetailsGroup
                        title="Making a colour variant?"
                        summary="Copy craft, weave and making steps from a product you already have"
                        defaultOpen={Boolean(switchButton)}
                      >
                        <CreateProductHeader
                          {...props}
                          handleOnInputChangeFilters={handleOnInputChangeFilters}
                          handleOnchangeProductFilter={handleOnchangeProductFilter}
                          productOptions={productOptions}
                          selectedProduct={selectedProduct}
                          handleResetData={handleResetData}
                          handleSwitchButton={handleSwitchButton}
                          switchButton={switchButton}
                        />
                      </DetailsGroup>
                    )}
                    <div className="ps-card">
                      <PhotoGrid
                      photos={baseImageLogo}
                      slots={viewSlotsFor(form)}
                      skipped={normalizeSkipped(form?.mediaViewsSkipped)}
                      onAddFiles={(files, view) =>
                        uploadFiles({ fileArr: fileArrayLogo, fileObject: fileObjLogo, name: "logo", files, view })
                      }
                      onSetView={onSetPhotoView}
                      onSkipView={onSkipPhotoView}
                      onPin={onSetPin}
                      onToggleShow={onSetIndexDesign}
                      onDelete={handleDeleteLogo}
                      nameParts={{ name: form?.productName, loomNum: form?.loomNum }}
                      onPreview={(item) => {
                        handleOpen();
                        handleSetImage(item);
                      }}
                    />
                    </div>
                    <p className="ps-note">
                      <b>Nothing here is required.</b> Empty boxes are the reminder — blouse and video are the ones studios miss. Tap one to shoot it, already tagged; extra photos can be tagged later.
                    </p>
                  </ProductStepPanel>
                  <ProductStepPanel id="basics" active={step}>
                    <div className="userPd ps-card">
                      <div className="formDiv">
                        <Row className="ps-row-2">
                      <Col xs={12} md={4}>
                        <Label>
                          Product name<span>*</span>
                          {form?.orgSrNo ? <i className="ps-label-hint" title="Set automatically, one number per piece">Studio SN #{form.orgSrNo}</i> : null}
                        </Label>
                        <Input
                          name="productName"
                          id="productName"
                          className="form-control"
                          placeholder="e.g. Chiffon jangla butidar, meena pallu"
                          value={form?.productName}
                          // disabled={
                          //   form?.typeOfSareeByDesign?.value?.length > 0
                          //     ? true
                          //     : false
                          // }
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "productName",
                              value: e.target.value,
                            });
                            handleChangeDebounce({
                              name: "product",
                              artform: form?.artform?.value,
                              type: form?.type?.value,
                              category: form?.category?.value,
                              subCategory: form?.subCategory?.value,
                              weaveType: form?.weaveType?.value,
                              productName: e.target.value,
                            });
                          }}
                        />
                        {Error.product && !form?.productName ? (
                          <p className="RequiredField">{Error?.product} </p>
                        ) : (
                          ""
                        )}
                        {form?.productName &&
                          form?.productName === filterProduct ? (
                          // filterValue?.product === ""
                          <p className="RequiredField">
                            Product name already exists
                          </p>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col xs={12} md={4}>
                        <Label>
                          Colour<span>*</span>
                          <i className="ps-label-hint">tap or type</i>
                        </Label>
                        <Input
                          name="variantColor"
                          id="variantColor"
                          className="form-control"
                          placeholder="e.g. Peacock blue, gold border"
                          value={form?.variantCode}
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "variantCode",
                              value: e.target.value,
                            });
                          }}
                        />
                        <ColourChips
                          value={form?.variantCode}
                          onPick={(value) => {
                            setUserEdited(true);
                            handleOnInputChange({ name: "variantCode", value });
                          }}
                        />
                        {Error.variantCode && !form?.variantCode ? (
                          <p className="RequiredField">{Error?.variantCode} </p>
                        ) : (
                          ""
                        )}
                      </Col>
                        </Row>
                      </div>
                      <div className="formDiv">
                        <CategoryPathPicker
                          value={form}
                          onPick={(path: any) => {
                            setUserEdited(true);
                            pickCategoryPath(path);
                          }}
                          levelsOpen={levelsOpen}
                          onShowLevels={() => setLevelsOpen(true)}
                        />
                      </div>
                      {levelsOpen ? (
                        <div className="formDiv ReactSelectDiv">
                          <Row>
                      <Col xs={12} md={4}>
                        <Label>
                          Artform <span>*</span>
                        </Label>
                        <div className="formDivSub">
                          <Select
                            className="React_selector text-white"
                            classNamePrefix="react-select"
                            placeholder="Select"
                            // isSearchable
                            name="artform"
                            id="artform"
                            value={form?.artform}
                            options={artformOptions}
                            // components={{ MenuList: SelectMenuButton }}
                            onChange={(e: any) => {
                              handleOnInputChange({
                                name: "artform",
                                value: e,
                              });
                            }}
                            onInputChange={(e) => {
                              handleOnInputChangeFilters({
                                name: "artform",
                                value: e,
                              });
                            }}
                          />
                          <div className="DivSep"></div>
                          <div className="formAddDiv">
                            <AddIcon openModal={handleOpenArtform} />
                          </div>
                        </div>

                        {Error.artform && !masterIdFromRef(form?.artform) ? (
                          <p className="RequiredField">{Error?.artform} </p>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col xs={12} md={4}>
                        <Label>
                          Type <span>*</span>
                        </Label>
                        <div className="formDivSub">
                          <Select
                            className="React_selector text-white"
                            classNamePrefix="react-select"
                            placeholder="Select"
                            // isSearchable
                            name="type"
                            id="type"
                            value={form?.type}
                            options={
                              form?.artform?.value
                                ? typeOptions
                                : [
                                  {
                                    label: (
                                      <p className="req">
                                        ***Please select Artform***
                                      </p>
                                    ),
                                    value: "",
                                  },
                                ]
                            }
                            // components={
                            //   form?.artform?.value && {
                            //     MenuList: SelectMenuButtonForType,
                            //   }
                            // }
                            onChange={(e: any) => {
                              handleOnInputChange({
                                name: "type",
                                value: e,
                              });
                            }}
                            onInputChange={(e) =>
                              handleOnInputChangeFilters({
                                name: "type",
                                value: e,
                              })
                            }
                          />
                          <div className="DivSep"></div>
                          <div className="formAddDiv">
                            <AddIcon openModal={handleOpenType} />
                          </div>
                        </div>
                        {Error.type && !masterIdFromRef(form?.type) ? (
                          <p className="RequiredField">{Error?.type} </p>
                        ) : (
                          ""
                        )}
                        {/* {filterValue?.type &&
                        new Map(
                          typeOptions.map((obj: any) => {
                            return [obj.value, obj.labe];
                          })
                        ).has(filterValue?.type) == false ? (
                          <p className="RequiredField">
                            Type is not a part of selected artform
                          </p>
                        ) : (
                          ""
                        )} */}
                      </Col>
                      <Col xs={12} md={4}>
                        <Label>
                          Category <span>*</span>
                        </Label>
                        <div className="formDivSub">
                          <Select
                            className="React_selector text-white"
                            classNamePrefix="react-select"
                            placeholder="Select"
                            isSearchable
                            name="Category"
                            id="Category"
                            value={form?.category}
                            options={
                              form?.type?.value
                                ? categoryOptions
                                : [
                                  {
                                    label: (
                                      <p className="req">
                                        ***Please select type***
                                      </p>
                                    ),
                                    value: "",
                                  },
                                ]
                            }
                            // components={
                            //   form?.type?.value && {
                            //     MenuList: SelectMenuButtonForCategory,
                            //   }
                            // }
                            onChange={(e: any) => {
                              handleOnInputChange({
                                name: "category",
                                value: e,
                              });
                            }}
                            onInputChange={(e) =>
                              handleOnInputChangeFilters({
                                name: "category",
                                value: e,
                              })
                            }
                          />
                          <div className="DivSep"></div>
                          <div className="formAddDiv">
                            <AddIcon openModal={handleOpenCategory} />
                          </div>
                        </div>
                        {Error.category && !masterIdFromRef(form?.category) ? (
                          <p className="RequiredField">{Error?.category} </p>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col xs={12} md={4}>
                        <Label>
                          Sub-Category <span>*</span>
                        </Label>
                        <div className="formDivSub">
                          <Select
                            className="React_selector text-white"
                            classNamePrefix="react-select"
                            placeholder="Select"
                            // isSearchable
                            name="subCategory"
                            id="subCategory"
                            value={form?.subCategory}
                            options={
                              form?.category?.value
                                ? subCategoryOptions
                                : [
                                  {
                                    label: (
                                      <p className="req">
                                        ***Please select category***
                                      </p>
                                    ),
                                    value: "",
                                  },
                                ]
                            }
                            // components={
                            //   form?.category?.value && {
                            //     MenuList: SelectMenuButtonForSubCategory,
                            //   }
                            // }
                            onChange={(e: any) => {
                              handleOnInputChange({
                                name: "subCategory",
                                value: e,
                              });
                            }}
                            onInputChange={(e) =>
                              handleOnInputChangeFilters({
                                name: "subCategory",
                                value: e,
                              })
                            }
                          />
                          <div className="DivSep"></div>
                          <div className="formAddDiv">
                            <AddIcon openModal={handleOpenSubCategory} />
                          </div>
                        </div>
                        {Error.subCategory && !masterIdFromRef(form?.subCategory) ? (
                          <p className="RequiredField">{Error?.subCategory} </p>
                        ) : (
                          ""
                        )}
                        {/* {filterValue?.subCategory &&
                        new Map(
                          subCategoryOptions.map((obj: any) => {
                            return [obj.value, obj.labe];
                          })
                        ).has(filterValue?.subCategory) == false ? (
                          <p className="RequiredField">
                            Sub-Category is not a part of selected category
                          </p>
                        ) : (
                          ""
                        )} */}
                      </Col>
                      {weaveTypeApplicable ? (
                      <Col xs={12} md={4}>
                        <Label>
                          Weave Type <span>*</span>
                        </Label>
                        <div className="formDivSub">
                          <Select
                            className="React_selector text-white"
                            classNamePrefix="react-select"
                            placeholder="Select"
                            // isSearchable
                            name="weaveType"
                            id="weaveType"
                            value={form?.weaveType}
                            options={
                              form?.subCategory?.value
                                ? weaveTypeOptions
                                : [
                                  {
                                    label: (
                                      <p className="req">
                                        ***Please select sub-category***
                                      </p>
                                    ),
                                    value: "",
                                  },
                                ]
                            }
                            onChange={(e: any) => {
                              handleOnInputChange({
                                name: "weaveType",
                                value: e,
                              });
                            }}
                            onInputChange={(e) =>
                              handleOnInputChangeFilters({
                                name: "weaveType",
                                value: e,
                              })
                            }
                          />
                          <div className="DivSep"></div>
                          <div className="formAddDiv">
                            <AddIcon openModal={handleOpenWeaveType} />
                          </div>
                        </div>
                        {Error.weaveType && !masterIdFromRef(form?.weaveType) ? (
                          <p className="RequiredField">{Error?.weaveType} </p>
                        ) : (
                          ""
                        )}
                      </Col>
                      ) : null}
                          </Row>
                        </div>
                      ) : null}
                      {/* Only name, colour and category are needed to save a draft; the rest folds away so the
                          step fits a phone. Studio SN is set automatically (shown beside the name); price is in Details. */}
                      {isTypeTagsEnabled() ? (
                        <DetailsGroup
                          title="Type tags"
                          summary={`${(form?.typeTagIds || []).length} selected`}
                          defaultOpen={(form?.typeTagIds || []).length > 0}
                        >
                          <p className="ps-note">
                            Add every type that fits (katan, tanchoi, butidar…). Your category above stays the official record.
                          </p>
                          <TypeTagPicker
                            suggestFrom={{ name: form?.productName, subcategoryName: form?.subCategory?.label }}
                            value={form?.typeTagIds || []}
                            onChange={(typeTagIds) => {
                              setUserEdited?.(true);
                              setForm((current: any) => ({ ...current, typeTagIds }));
                            }}
                          />
                        </DetailsGroup>
                      ) : null}
                      <DetailsGroup
                        title="More details (optional)"
                        summary="order, description"
                        defaultOpen={Boolean(form?.studioOrderId || String(form?.description || "").trim())}
                      >
                      <div className="formDiv">
                        <Row>
                      {canUseOrders(authUser?.users?.role) ? (
                        <Col xs={12} md={4}>
                          <Label>Order number (optional)</Label>
                          <StudioOrderSelect
                            valueId={form?.studioOrderId || ""}
                            valueCode={form?.studioOrderCode || ""}
                            onChange={({ id, code }) => {
                              setForm((current: any) => ({
                                ...current,
                                studioOrderId: id,
                                studioOrderCode: code,
                              }));
                            }}
                          />
                        </Col>
                      ) : null}
                          <ProductDescriptionField
                            value={form?.description}
                            onChange={(value) => handleOnInputChange({ name: "description", value })}
                          />
                        </Row>
                        <WriteFromPhotos
                          form={form}
                          photos={baseImageLogo}
                          onWrite={(value) => {
                            setUserEdited(true);
                            handleOnInputChange({ name: "description", value });
                          }}
                        />
                      </div>
                      </DetailsGroup>
                    </div>
                    <p className="ps-note">
                      Only <b>name</b>, <b>colour</b> and <b>category</b> are needed. Next saves this as a <b>draft</b> — it stays a
                      draft while it’s on the loom — and opens Details, Making and Review.
                    </p>
                  </ProductStepPanel>
                </div>
              </div>
            </main>
            <ProductStepFooter>
              {step === "photos" ? (
                <StepButton kind="blue" wide next onClick={() => goToStep("basics")}>
                  Next: Basics
                </StepButton>
              ) : (
                <>
                  <StepButton onClick={() => goToStep("photos")}>Back</StepButton>
                  <StepButton
                    kind="blue"
                    wide
                    next
                    onClick={() => saveDraftAndContinue("details")}
                    disabled={Boolean(loading || loader || saving) || uploadSummary.unresolved > 0}
                    aria-busy={saving === "save"}
                  >
                    {saving === "save"
                      ? "Saving draft…"
                      : uploadSummary.unresolved > 0
                        ? `Waiting for ${uploadSummary.unresolved} upload${uploadSummary.unresolved === 1 ? "" : "s"}…`
                        : (
                          <>
                            <span className="ps-foot__long">Save draft · </span>Next: Details
                          </>
                        )}
                  </StepButton>
                </>
              )}
            </ProductStepFooter>
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  getUsers,
  getArtforms,
  getTypes,
  getCategory,
  getSubCategorys,
  getWeaveType,
  createUser,
  updateUsers,
  uploadImages1,
  uploadImages,
  fetchProfilePresignedUrl,
  fetchProductWeavingPresignedUrl,
  fetchProductDesigningPresignedUrl,
  fetchProductFinishingPresignedUrl,
  fetchProductDyingPresignedUrl,
  createProduct,
  getProducts,
})(CreateProduct);
